(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888,1707],{

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SwipeableDrawer_SwipeableDrawer; }
});

// UNUSED EXPORTS: reset

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeProps/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(16600);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/base/NoSsr/NoSsr.js





/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/base/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/base/api/no-ssr/)
 */
function NoSsr(props) {
  const {
    children,
    defer = false,
    fallback = null
  } = props;
  const [mountedState, setMountedState] = react.useState(false);
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  react.useEffect(() => {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: mountedState ? children : fallback
  });
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var NoSsr_NoSsr = (NoSsr);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js
var Transition = __webpack_require__(96630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/debounce.js
var debounce = __webpack_require__(75400);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(84771);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/transitions/utils.js
var utils = __webpack_require__(53566);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(57577);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Slide/Slide.js


const _excluded = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








 // Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.



function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0,ownerWindow/* default */.Z)(node);
  let transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  let offsetX = 0;
  let offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }

    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }

  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }

    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }

  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }

    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  } // direction === 'down'


  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }

  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}

function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}

function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Slide = /*#__PURE__*/react.forwardRef(function Slide(props, ref) {
  const theme = (0,useTheme/* default */.Z)();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    addEndListener,
    appear = true,
    children,
    container: containerProp,
    direction = 'down',
    easing: easingProp = defaultEasing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition/* default */.ZP
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const childrenRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, childrenRef, ref);

  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };

  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0,utils/* reflow */.n)(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0,utils/* getTransitionProps */.C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,esm_extends/* default */.Z)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0,esm_extends/* default */.Z)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,utils/* getTransitionProps */.C)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };

  const updatePosition = react.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  react.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    const handleResize = (0,debounce/* default */.Z)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0,ownerWindow/* default */.Z)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  react.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
        ref: handleRef,
        style: (0,esm_extends/* default */.Z)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Slide_Slide = (Slide);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(70918);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(36622);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var styles_useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js + 2 modules
var styled = __webpack_require__(67074);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Drawer/drawerClasses.js

function getDrawerUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiDrawer', slot);
}
const drawerClasses = (0,generateUtilityClasses/* default */.Z)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
/* harmony default export */ var Drawer_drawerClasses = ((/* unused pure expression or super */ null && (drawerClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js


const Drawer_excluded = ["BackdropProps"],
      _excluded2 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];















const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};

const useUtilityClasses = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0,capitalize/* default */.Z)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0,capitalize/* default */.Z)(anchor)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getDrawerUtilityClass, classes);
};

const DrawerRoot = (0,styled/* default */.ZP)(Modal/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
}));
const DrawerDockedRoot = (0,styled/* default */.ZP)('div', {
  shouldForwardProp: styled/* rootShouldForwardProp */.FO,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0,capitalize/* default */.Z)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0,capitalize/* default */.Z)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

const Drawer = /*#__PURE__*/react.forwardRef(function Drawer(inProps, ref) {
  const props = (0,styles_useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    anchor: anchorProp = 'left',
    BackdropProps,
    children,
    className,
    elevation = 16,
    hideBackdrop = false,
    ModalProps: {
      BackdropProps: BackdropPropsProp
    } = {},
    onClose,
    open = false,
    PaperProps = {},
    SlideProps,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Slide_Slide,
    transitionDuration = defaultTransitionDuration,
    variant = 'temporary'
  } = props,
        ModalProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ModalProps, Drawer_excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.


  const mounted = react.useRef(false);
  react.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor(theme, anchorProp);
  const anchor = anchorProp;

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);

  const classes = useUtilityClasses(ownerState);

  const drawer = /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerPaper, (0,esm_extends/* default */.Z)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,clsx_m/* default */.Z)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));

  if (variant === 'permanent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }

  const slidingDrawer = /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));

  if (variant === 'persistent') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerDockedRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  } // variant === temporary


  return /*#__PURE__*/(0,jsx_runtime.jsx)(DrawerRoot, (0,esm_extends/* default */.Z)({
    BackdropProps: (0,esm_extends/* default */.Z)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0,clsx_m/* default */.Z)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Drawer_Drawer = (Drawer);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(47505);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(26432);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEnhancedEffect.js
var utils_useEnhancedEffect = __webpack_require__(63289);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/SwipeableDrawer/SwipeArea.js


const SwipeArea_excluded = ["anchor", "classes", "className", "width", "style"];







const SwipeAreaRoot = (0,styled/* default */.ZP)('div')(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  zIndex: theme.zIndex.drawer - 1
}, ownerState.anchor === 'left' && {
  right: 'auto'
}, ownerState.anchor === 'right' && {
  left: 'auto',
  right: 0
}, ownerState.anchor === 'top' && {
  bottom: 'auto',
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  bottom: 0,
  right: 0
}));
/**
 * @ignore - internal component.
 */

const SwipeArea = /*#__PURE__*/react.forwardRef(function SwipeArea(props, ref) {
  const {
    anchor,
    classes = {},
    className,
    width,
    style
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, SwipeArea_excluded);

  const ownerState = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SwipeAreaRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0,capitalize/* default */.Z)(anchor)}`], className),
    ref: ref,
    style: (0,esm_extends/* default */.Z)({
      [isHorizontal(anchor) ? 'width' : 'height']: width
    }, style),
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var SwipeableDrawer_SwipeArea = (SwipeArea);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/SwipeableDrawer/SwipeableDrawer.js


const SwipeableDrawer_excluded = ["BackdropProps"],
      SwipeableDrawer_excluded2 = ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"];












 // This value is closed to what browsers are using internally to
// trigger a native scroll.



const UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.

const DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

let claimedSwipeInstance = null; // Exported for test purposes.

function SwipeableDrawer_reset() {
  claimedSwipeInstance = null;
}

function calculateCurrentX(anchor, touches, doc) {
  return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}

function calculateCurrentY(anchor, touches, containerWindow) {
  return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}

function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}

function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */


function getDomTreeShapes(element, rootNode) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
  const domTreeShapes = [];

  while (element && element !== rootNode.parentElement) {
    const style = (0,ownerWindow/* default */.Z)(rootNode).getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {// noop
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push(element);
    }

    element = element.parentElement;
  }

  return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */


function computeHasNativeHandler({
  domTreeShapes,
  start,
  current,
  anchor
}) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
  const axisProperties = {
    scrollPosition: {
      x: 'scrollLeft',
      y: 'scrollTop'
    },
    scrollLength: {
      x: 'scrollWidth',
      y: 'scrollHeight'
    },
    clientLength: {
      x: 'clientWidth',
      y: 'clientHeight'
    }
  };
  return domTreeShapes.some(shape => {
    // Determine if we are going backward or forward.
    let goingForward = current >= start;

    if (anchor === 'top' || anchor === 'left') {
      goingForward = !goingForward;
    }

    const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
    const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
    const areNotAtStart = scrollPosition > 0;
    const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return true;
    }

    return false;
  });
}

const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const SwipeableDrawer = /*#__PURE__*/react.forwardRef(function SwipeableDrawer(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    name: 'MuiSwipeableDrawer',
    props: inProps
  });
  const theme = (0,useTheme/* default */.Z)();
  const transitionDurationDefault = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    anchor = 'left',
    disableBackdropTransition = false,
    disableDiscovery = false,
    disableSwipeToOpen = iOS,
    hideBackdrop,
    hysteresis = 0.52,
    minFlingVelocity = 450,
    ModalProps: {
      BackdropProps
    } = {},
    onClose,
    onOpen,
    open,
    PaperProps = {},
    SwipeAreaProps,
    swipeAreaWidth = 20,
    transitionDuration = transitionDurationDefault,
    variant = 'temporary'
  } = props,
        ModalPropsProp = (0,objectWithoutPropertiesLoose/* default */.Z)(props.ModalProps, SwipeableDrawer_excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, SwipeableDrawer_excluded2);

  const [maybeSwiping, setMaybeSwiping] = react.useState(false);
  const swipeInstance = react.useRef({
    isSwiping: null
  });
  const swipeAreaRef = react.useRef();
  const backdropRef = react.useRef();
  const paperRef = react.useRef();
  const touchDetected = react.useRef(false); // Ref for transition duration based on / to match swipe speed

  const calculatedDurationRef = react.useRef(); // Use a ref so the open value used is always up to date inside useCallback.

  (0,utils_useEnhancedEffect/* default */.Z)(() => {
    calculatedDurationRef.current = null;
  }, [open]);
  const setPosition = react.useCallback((translate, options = {}) => {
    const {
      mode = null,
      changeTransition = true
    } = options;
    const anchorRtl = getAnchor(theme, anchor);
    const rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
    const horizontalSwipe = isHorizontal(anchor);
    const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
    const drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    let transition = '';

    if (mode) {
      transition = theme.transitions.create('all', (0,utils/* getTransitionProps */.C)({
        easing: undefined,
        style: undefined,
        timeout: transitionDuration
      }, {
        mode
      }));
    }

    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }

    if (!disableBackdropTransition && !hideBackdrop) {
      const backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);

      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  const handleBodyTouchEnd = (0,useEventCallback/* default */.Z)(nativeEvent => {
    if (!touchDetected.current) {
      return;
    }

    claimedSwipeInstance = null;
    touchDetected.current = false;
    setMaybeSwiping(false); // The swipe wasn't started.

    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }

    swipeInstance.current.isSwiping = null;
    const anchorRtl = getAnchor(theme, anchor);
    const horizontal = isHorizontal(anchor);
    let current;

    if (horizontal) {
      current = calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0,ownerDocument/* default */.Z)(nativeEvent.currentTarget));
    } else {
      current = calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0,ownerWindow/* default */.Z)(nativeEvent.currentTarget));
    }

    const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    const maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    const currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    const translateRatio = currentTranslate / maxTranslate;

    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      // Calculate transition duration to match swipe speed
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
    }

    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        // Reset the position, the swipe was aborted.
        setPosition(0, {
          mode: 'exit'
        });
      }

      return;
    }

    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      // Reset the position, the swipe was aborted.
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: 'enter'
      });
    }
  });
  const handleBodyTouchMove = (0,useEventCallback/* default */.Z)(nativeEvent => {
    // the ref may be null when a parent component updates while swiping
    if (!paperRef.current || !touchDetected.current) {
      return;
    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer


    if (claimedSwipeInstance !== null && claimedSwipeInstance !== swipeInstance.current) {
      return;
    }

    const anchorRtl = getAnchor(theme, anchor);
    const horizontalSwipe = isHorizontal(anchor);
    const currentX = calculateCurrentX(anchorRtl, nativeEvent.touches, (0,ownerDocument/* default */.Z)(nativeEvent.currentTarget));
    const currentY = calculateCurrentY(anchorRtl, nativeEvent.touches, (0,ownerWindow/* default */.Z)(nativeEvent.currentTarget));

    if (open && paperRef.current.contains(nativeEvent.target) && claimedSwipeInstance === null) {
      const domTreeShapes = getDomTreeShapes(nativeEvent.target, paperRef.current);
      const hasNativeHandler = computeHasNativeHandler({
        domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor
      });

      if (hasNativeHandler) {
        claimedSwipeInstance = true;
        return;
      }

      claimedSwipeInstance = swipeInstance.current;
    } // We don't know yet.


    if (swipeInstance.current.isSwiping == null) {
      const dx = Math.abs(currentX - swipeInstance.current.startX);
      const dy = Math.abs(currentY - swipeInstance.current.startY);
      const definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

      if (definitelySwiping && nativeEvent.cancelable) {
        nativeEvent.preventDefault();
      }

      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;

        if (!definitelySwiping) {
          handleBodyTouchEnd(nativeEvent);
          return;
        } // Shift the starting point.


        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= DRAG_STARTED_SIGNAL;
          } else {
            swipeInstance.current.startY -= DRAG_STARTED_SIGNAL;
          }
        }
      }
    }

    if (!swipeInstance.current.isSwiping) {
      return;
    }

    const maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;

    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }

    const translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);

    if (open) {
      if (!swipeInstance.current.paperHit) {
        const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;

        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }

    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }

    const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.

    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.

    if (nativeEvent.cancelable) {
      nativeEvent.preventDefault();
    }

    setPosition(translate);
  });
  const handleBodyTouchStart = (0,useEventCallback/* default */.Z)(nativeEvent => {
    // We are not supposed to handle this touch move.
    // Example of use case: ignore the event if there is a Slider.
    if (nativeEvent.defaultPrevented) {
      return;
    } // We can only have one node at the time claiming ownership for handling the swipe.


    if (nativeEvent.defaultMuiPrevented) {
      return;
    } // At least one element clogs the drawer interaction zone.


    if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) {
      return;
    }

    const anchorRtl = getAnchor(theme, anchor);
    const horizontalSwipe = isHorizontal(anchor);
    const currentX = calculateCurrentX(anchorRtl, nativeEvent.touches, (0,ownerDocument/* default */.Z)(nativeEvent.currentTarget));
    const currentY = calculateCurrentY(anchorRtl, nativeEvent.touches, (0,ownerWindow/* default */.Z)(nativeEvent.currentTarget));

    if (!open) {
      if (disableSwipeToOpen || nativeEvent.target !== swipeAreaRef.current) {
        return;
      }

      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }

    nativeEvent.defaultMuiPrevented = true;
    claimedSwipeInstance = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    setMaybeSwiping(true);

    if (!open && paperRef.current) {
      // The ref may be null when a parent component updates while swiping.
      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -DRAG_STARTED_SIGNAL), {
        changeTransition: false
      });
    }

    swipeInstance.current.velocity = 0;
    swipeInstance.current.lastTime = null;
    swipeInstance.current.lastTranslate = null;
    swipeInstance.current.paperHit = false;
    touchDetected.current = true;
  });
  react.useEffect(() => {
    if (variant === 'temporary') {
      const doc = (0,ownerDocument/* default */.Z)(paperRef.current);
      doc.addEventListener('touchstart', handleBodyTouchStart); // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
      // It only needs to prevent scrolling on the drawer's content when open.
      // When closed, the overlay prevents scrolling.

      doc.addEventListener('touchmove', handleBodyTouchMove, {
        passive: !open
      });
      doc.addEventListener('touchend', handleBodyTouchEnd);
      return () => {
        doc.removeEventListener('touchstart', handleBodyTouchStart);
        doc.removeEventListener('touchmove', handleBodyTouchMove, {
          passive: !open
        });
        doc.removeEventListener('touchend', handleBodyTouchEnd);
      };
    }

    return undefined;
  }, [variant, open, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  react.useEffect(() => () => {
    // We need to release the lock.
    if (claimedSwipeInstance === swipeInstance.current) {
      claimedSwipeInstance = null;
    }
  }, []);
  react.useEffect(() => {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Drawer_Drawer, (0,esm_extends/* default */.Z)({
      open: variant === 'temporary' && maybeSwiping ? true : open,
      variant: variant,
      ModalProps: (0,esm_extends/* default */.Z)({
        BackdropProps: (0,esm_extends/* default */.Z)({}, BackdropProps, {
          ref: backdropRef
        })
      }, ModalPropsProp),
      hideBackdrop: hideBackdrop,
      PaperProps: (0,esm_extends/* default */.Z)({}, PaperProps, {
        style: (0,esm_extends/* default */.Z)({
          pointerEvents: variant === 'temporary' && !open ? 'none' : ''
        }, PaperProps.style),
        ref: paperRef
      }),
      anchor: anchor,
      transitionDuration: calculatedDurationRef.current || transitionDuration,
      onClose: onClose,
      ref: ref
    }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/(0,jsx_runtime.jsx)(NoSsr_NoSsr, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SwipeableDrawer_SwipeArea, (0,esm_extends/* default */.Z)({
        anchor: anchor,
        ref: swipeAreaRef,
        width: swipeAreaWidth
      }, SwipeAreaProps))
    })]
  });
});
 false ? 0 : void 0;
/* harmony default export */ var SwipeableDrawer_SwipeableDrawer = (SwipeableDrawer);

/***/ }),

/***/ 74681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mf": function() { return /* reexport */ FilterBoxCheckbox; },
  "_k": function() { return /* reexport */ FilterBoxSlider; }
});

// UNUSED EXPORTS: Indicator

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/indector/Indicator.jsx




var Indicator = function Indicator() {
  return /*#__PURE__*/_jsx("div", {
    className: styles.indector_wrapper,
    children: /*#__PURE__*/_jsxs("ul", {
      children: [/*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Australia"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Melbourne"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "$4.5-$40"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Australia"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "Melbourne"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      }), /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx("span", {
          children: "$4.5-$40"
        }), /*#__PURE__*/_jsx("button", {
          children: "x"
        })]
      })]
    })
  });
};
/* harmony default export */ var indector_Indicator = ((/* unused pure expression or super */ null && (Indicator)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(51627);
// EXTERNAL MODULE: ./node_modules/react-checkbox-tree/lib/index.browser.js
var index_browser = __webpack_require__(28388);
var index_browser_default = /*#__PURE__*/__webpack_require__.n(index_browser);
// EXTERNAL MODULE: ./node_modules/react-checkbox-tree/lib/react-checkbox-tree.css
var react_checkbox_tree = __webpack_require__(37846);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_checkbox.module.scss
var filter_box_checkbox_module = __webpack_require__(54650);
var filter_box_checkbox_module_default = /*#__PURE__*/__webpack_require__.n(filter_box_checkbox_module);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_checkbox.jsx

var _excluded = ["data", "title", "selected", "expanded", "search", "loading", "type"];








 // types (collapsible, normal)



var FilterBoxCheckbox = function FilterBoxCheckbox(_ref) {
  var data = _ref.data,
      title = _ref.title,
      selected = _ref.selected,
      expanded = _ref.expanded,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "collapsible" : _ref$type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useState = (0,react.useState)(true),
      cardOpen = _useState[0],
      setCardOpen = _useState[1];

  var handleCard = function handleCard() {
    setCardOpen(!cardOpen);
  };

  var onCheck = function onCheck(checked) {
    if (props.onChange) props.onChange(checked);
  };

  var onExpand = function onExpand(expanded) {
    if (props.getExpand) props.getExpand(expanded);
  };

  if (data && data.length > 0) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [type == "collapsible" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_box_checkbox_module_default()).filter_option,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          onClick: handleCard,
          className: (filter_box_checkbox_module_default()).option_title_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (filter_box_checkbox_module_default()).option_title,
            children: title || ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (filter_box_checkbox_module_default()).icon,
            children: cardOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronUp */.rH8, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronDown */.bTu, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (filter_box_checkbox_module_default()).filter_checkbox_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
            "in": cardOpen,
            timeout: "auto",
            unmountOnExit: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_browser_default()), {
              checked: selected,
              expanded: expanded,
              nodes: data,
              className: "test",
              onCheck: onCheck,
              onExpand: onExpand,
              disabled: loading,
              icons: {
                check: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
                uncheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBoxOutlineBlank */.hrt, {}),
                halfCheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
                expandClose: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}),
                expandOpen: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiMinus */.bQR, {}),
                expandAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdExpand */.Bds, {}),
                collapseAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCloseFullscreen */.$WQ, {}),
                parentClose: false,
                parentOpen: false,
                leaf: false
              }
            })
          })
        })]
      }), type == "normal" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (filter_box_checkbox_module_default()).filter_checkbox_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_browser_default()), {
          checked: selected,
          expanded: expanded,
          nodes: data,
          className: "test",
          onCheck: onCheck,
          onExpand: onExpand,
          disabled: loading,
          icons: {
            check: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
            uncheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBoxOutlineBlank */.hrt, {}),
            halfCheck: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCheckBox */.y5A, {}),
            expandClose: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}),
            expandOpen: /*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiMinus */.bQR, {}),
            expandAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdExpand */.Bds, {}),
            collapseAll: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdCloseFullscreen */.$WQ, {}),
            parentClose: false,
            parentOpen: false,
            leaf: false
          }
        })
      })]
    });
  }
};
/* harmony default export */ var filter_box_checkbox = ((/* unused pure expression or super */ null && (FilterBoxCheckbox)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slider/Slider.js + 4 modules
var Slider = __webpack_require__(45996);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_slider.module.scss
var filter_box_slider_module = __webpack_require__(4644);
var filter_box_slider_module_default = /*#__PURE__*/__webpack_require__.n(filter_box_slider_module);
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/filter_box/filter_box_slider.jsx


var filter_box_slider_excluded = ["title", "range", "value", "onChange", "loading", "icon", "offset", "type"];



 // type (collapsible, normal)



var FilterBoxSlider = function FilterBoxSlider(_ref) {
  var _range$, _range$2, _range$3, _range$4;

  var title = _ref.title,
      range = _ref.range,
      value = _ref.value,
      onChange = _ref.onChange,
      loading = _ref.loading,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? false : _ref$offset,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "collapsible" : _ref$type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, filter_box_slider_excluded);

  var _React$useState = react.useState(true),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = react.useState(value),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      valueState = _React$useState4[0],
      setValue = _React$useState4[1];

  var handleClick = function handleClick() {
    setOpen(!open);
  };

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  var changeCommitted = function changeCommitted(event, newValue) {
    if (onChange) {
      onChange(newValue);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [type == "collapsible" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (filter_box_slider_module_default()).filter_option,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        onClick: handleClick,
        className: (filter_box_slider_module_default()).option_title_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (filter_box_slider_module_default()).option_title,
          children: title || ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (filter_box_slider_module_default()).icon,
          children: open ? /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronUp */.rH8, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronDown */.bTu, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
        "in": open,
        timeout: "auto",
        unmountOnExit: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filter_box_slider_module_default()).filter_slider_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (filter_box_slider_module_default()).slider_range_text,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (filter_box_slider_module_default()).currncy,
              children: [offset && offset == "left" && icon && icon, valueState && valueState[0], " ", offset && offset == "right" && icon && icon]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (filter_box_slider_module_default()).currncy,
              children: [offset && offset == "left" && icon && icon, valueState && valueState[1], " ", offset && offset == "right" && icon && icon]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.ZP, {
            value: valueState,
            onChange: handleChange,
            onChangeCommitted: changeCommitted,
            valueLabelDisplay: "off",
            min: (_range$ = range[0]) !== null && _range$ !== void 0 ? _range$ : 0,
            max: (_range$2 = range[1]) !== null && _range$2 !== void 0 ? _range$2 : 1,
            className: (filter_box_slider_module_default()).slideContainer,
            disabled: loading
          })]
        })
      })]
    }), type == "normal" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (filter_box_slider_module_default()).filter_slider_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filter_box_slider_module_default()).slider_range_text,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (filter_box_slider_module_default()).currncy,
          children: [offset && offset == "left" && icon && icon, valueState && valueState[0], " ", offset && offset == "right" && icon && icon]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (filter_box_slider_module_default()).currncy,
          children: [offset && offset == "left" && icon && icon, valueState && valueState[1], " ", offset && offset == "right" && icon && icon]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Slider/* default */.ZP, {
        value: valueState,
        onChange: handleChange,
        onChangeCommitted: changeCommitted,
        valueLabelDisplay: "off",
        min: (_range$3 = range[0]) !== null && _range$3 !== void 0 ? _range$3 : 0,
        max: (_range$4 = range[1]) !== null && _range$4 !== void 0 ? _range$4 : 1,
        className: (filter_box_slider_module_default()).slideContainer,
        disabled: loading
      })]
    })]
  });
};
/* harmony default export */ var filter_box_slider = ((/* unused pure expression or super */ null && (FilterBoxSlider)));
;// CONCATENATED MODULE: ./_modules/study/common/advance_search/advance/index.js




/***/ }),

/***/ 316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CourseCard */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63750);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86893);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51649);
/* harmony import */ var _course_card_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81648);
/* harmony import */ var _course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);

var _excluded = ["link", "name", "level", "exams", "session", "duration", "month", "year", "amountFrom", "amountTo", "countryCurrency", "intakes", "isAlignRow"];









var CourseCard = function CourseCard(_ref) {
  var link = _ref.link,
      name = _ref.name,
      level = _ref.level,
      exams = _ref.exams,
      session = _ref.session,
      duration = _ref.duration,
      month = _ref.month,
      year = _ref.year,
      amountFrom = _ref.amountFrom,
      amountTo = _ref.amountTo,
      countryCurrency = _ref.countryCurrency,
      intakes = _ref.intakes,
      isAlignRow = _ref.isAlignRow,
      porps = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var intakeArray = (intakes === null || intakes === void 0 ? void 0 : intakes.length) > 0 ? intakes === null || intakes === void 0 ? void 0 : intakes.sort(function (a, b) {
    return a.intakeYear - b.intakeYear;
  }) : [];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card), " ").concat(isAlignRow ? (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().align_row) : ""),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      legacyBehavior: true,
      href: link,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h3", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_title),
          children: name
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("ul", {
      className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_info_lists),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_5__/* .IoMdSchool */ .TVA, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "Course Level"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: level
          })]
        })]
      }), duration && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_6__/* .AiOutlineClockCircle */ .cjn, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "Course Duration"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
            children: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .calcDuration */ .LF)(duration)
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_7__/* .BsCashStack */ .zzp, {
          style: {
            fontSize: "15px"
          },
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "1st Year Tution Fees"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
            children: [countryCurrency, " ", amountFrom ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .numFormatter */ .tV)(amountFrom) : "", amountTo && amountTo != 0 && " - " + (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .numFormatter */ .tV)(amountTo)]
          })]
        })]
      }), intakes && (intakes === null || intakes === void 0 ? void 0 : intakes.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_6__/* .AiOutlineCalendar */ .xHR, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: "Intake"
            }), (intakeArray === null || intakeArray === void 0 ? void 0 : intakeArray.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake), " relative"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_num),
                children: ["+", intakeArray.length - 1]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "uni-tooltip top",
                children: intakeArray.slice(1).map(function (intk, i) {
                  if (intk !== null && intk !== void 0 && intk.admissionSessionName && (intk === null || intk === void 0 ? void 0 : intk.admissionSessionName) != "") {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                      children: [intk === null || intk === void 0 ? void 0 : intk.admissionSessionName, ": ", intk === null || intk === void 0 ? void 0 : intk.intakeMonth, " ", intk === null || intk === void 0 ? void 0 : intk.intakeYear, " "]
                    }, i);
                  }
                })
              })]
            })]
          }), intakeArray.slice(0, 1).map(function (intk, i) {
            if (intk !== null && intk !== void 0 && intk.admissionSessionName && (intk === null || intk === void 0 ? void 0 : intk.admissionSessionName) != "") {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
                children: [intk === null || intk === void 0 ? void 0 : intk.admissionSessionName, ": ", intk === null || intk === void 0 ? void 0 : intk.intakeMonth, " ", intk === null || intk === void 0 ? void 0 : intk.intakeYear, " "]
              }, i);
            }
          })]
        })]
      }), exams && (exams === null || exams === void 0 ? void 0 : exams.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_8__/* .FiFileText */ .NOg, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: "Eligibility"
            }), (exams === null || exams === void 0 ? void 0 : exams.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake), " relative"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_num),
                children: ["+", exams.length - 1]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "uni-tooltip top",
                children: exams.slice(1).map(function (exm, i) {
                  var _exm$exam;

                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                    children: [exm === null || exm === void 0 ? void 0 : (_exm$exam = exm.exam) === null || _exm$exam === void 0 ? void 0 : _exm$exam.examName, ": ", exm === null || exm === void 0 ? void 0 : exm.score, " "]
                  }, i);
                })
              })]
            })]
          }), exams.slice(0, 1).map(function (exm, i) {
            var _exm$exam2;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
              className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
              children: [exm === null || exm === void 0 ? void 0 : (_exm$exam2 = exm.exam) === null || _exm$exam2 === void 0 ? void 0 : _exm$exam2.examName, ": ", exm === null || exm === void 0 ? void 0 : exm.score, " "]
            }, i);
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      legacyBehavior: true,
      href: link ? link : "#",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_link), " btn btn-primary"),
        children: "View Details"
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCard);

/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 97623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yQ": function() { return /* reexport */ UniBrief; },
  "gK": function() { return /* reexport */ UniHeroWithVideo; },
  "pA": function() { return /* reexport */ UniLinks; },
  "q6": function() { return /* reexport */ uni_profile_banner/* UniProfileBanner */.q; },
  "au": function() { return /* reexport */ UniProfileWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./_modules/study/common/play_btn_with_ripple/index.jsx
var play_btn_with_ripple = __webpack_require__(42422);
// EXTERNAL MODULE: ./_modules/study/university/uni_hero_with_video.module.scss
var uni_hero_with_video_module = __webpack_require__(47656);
var uni_hero_with_video_module_default = /*#__PURE__*/__webpack_require__.n(uni_hero_with_video_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/university/uni_hero_with_video.jsx



var ModalVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6635).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});





var UniHeroWithVideo = function UniHeroWithVideo(_ref) {
  var uniProfileData = _ref.uniProfileData;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (uni_hero_with_video_module_default()).uni_hero,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_hero_with_video_module_default()).video_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_hero_with_video_module_default()).overlay
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          layout: "responsive",
          width: 840,
          height: 450,
          blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
          placeholder: "blur",
          className: (uni_hero_with_video_module_default()).featured_image,
          src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.coverphotoLogoSrc) || (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
          alt: "Video Background"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(play_btn_with_ripple/* default */.Z, {
          onClick: function onClick() {
            return setOpen(true);
          }
        })]
      })
    }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.videoType) === "upload" && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "custom",
      autoplay: true,
      isOpen: isOpen,
      url: uniProfileData ? uniProfileData.videoSrc : "",
      onClose: function onClose() {
        return setOpen(false);
      }
    }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.videoType) === "embeded" && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "youtube",
      autoplay: true,
      isOpen: isOpen,
      videoId: uniProfileData ? uniProfileData.embedCode : "",
      onClose: function onClose() {
        return setOpen(false);
      }
    })]
  });
};
/* harmony default export */ var uni_hero_with_video = ((/* unused pure expression or super */ null && (UniHeroWithVideo)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Rating/Rating.js + 3 modules
var Rating = __webpack_require__(90926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(58735);
// EXTERNAL MODULE: ./_unisearch/common/index.js + 9 modules
var common = __webpack_require__(74155);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./_modules/study/university/uni_brief.module.scss
var uni_brief_module = __webpack_require__(47022);
var uni_brief_module_default = /*#__PURE__*/__webpack_require__.n(uni_brief_module);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/guest_form_review.jsx
var guest_form_review = __webpack_require__(17171);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/register_form_review.jsx
var register_form_review = __webpack_require__(25702);
;// CONCATENATED MODULE: ./_modules/study/university/uni_brief.jsx





















var FavoriteAction = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(726)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(180)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});

var ReviewOption = function ReviewOption(_ref) {
  var value = _ref.value,
      uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      existingComment = _ref.existingComment,
      onEdit = _ref.onEdit,
      getComment = _ref.getComment;

  switch (value) {
    case 0:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(guest_form_review/* default */.Z, {
        getData: getData,
        setModal: setModal,
        uniProfileData: uniProfileData
      });

    case 1:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(register_form_review/* default */.Z, {
        setModal: setModal,
        uniProfileData: uniProfileData,
        getData: getData,
        onEdit: onEdit,
        existingComment: existingComment,
        getComment: getComment
      });
  }
};

var UniBrief = function UniBrief(_ref2) {
  var _uniProfileData$docum, _uniProfileData$docum2;

  var uniProfileData = _ref2.uniProfileData,
      customClasses = _ref2.customClasses;
  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      modal = _useState[0],
      setModal = _useState[1];

  var _useState2 = (0,react.useState)(0),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      existingComment = _useState3[0],
      setExistingComment = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      onEdit = _useState4[0],
      setOnEdit = _useState4[1];

  var systemActions = (0,_actions/* useSystemActions */.x3)(); // get existing comment

  var getComment = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.get */.Z.get("/public/university-review/check/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug)).then(function (res) {
                if (!res.error && res.data) {
                  var data = res.data;
                  setExistingComment(data);
                  setOnEdit(true);
                } else {
                  setExistingComment({});
                  setOnEdit(false);
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getComment() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universitySlug && profileInfo && modal) {
      getComment();
    }
  }, [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug, profileInfo, modal]);
  (0,react.useEffect)(function () {
    if (profileInfo) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [profileInfo]);

  var getData = function getData() {};

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "".concat((uni_brief_module_default()).section_uni_brief, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_brief_module_default()).brief_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_brief_module_default()).brief_left_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (uni_brief_module_default()).uni_logo_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.logosrc) || (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/logo-placeholder.png"),
              alt: "University Logo"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).uni_brief_info,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityName
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUniversity */.Q7H, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universityType ? (0,helpers/* upperFirstLetter */.cK)(uniProfileData.universityType) : "", " ", "University, Estd ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.estd]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaMapMarkerAlt */.Nh4, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.cityName, ", ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.stateName]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiBook2Fill */.XbY, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalCourse, " ", (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalCourse) > 1 ? "Courses" : "Course"]
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_brief_module_default()).brief_right_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).rating_wrapper,
            children: [(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalRating) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_brief_module_default()).info_rating_number,
              children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating, " (", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalRating, ")"]
            }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_brief_module_default()).info_rating_stars,
              onClick: function onClick() {
                setModal(true);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Rating/* default */.Z, {
                name: "rating-read",
                value: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating) && parseInt(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating),
                readOnly: true
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            rel: "nofollow",
            className: (uni_brief_module_default()).uni_web_link,
            href: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.website,
            target: "_blank",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "International student website"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiLinkExternal */.rpH, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).compare_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteAction, {
              referance: "university",
              referanceId: parseInt(uniProfileData.universityId),
              is_favorite: (0,helpers/* isUniFavorite */.bt)(profileInfo, uniProfileData.universityId)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompareAction, {
              referance: "university",
              referanceId: parseInt(uniProfileData.universityId),
              is_compared: (0,helpers/* isUniCompare */.j1)(profileInfo, uniProfileData.universityId)
            }), uniProfileData && (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.documentInfo) && /*#__PURE__*/(0,jsx_runtime.jsx)(common/* DownloadGuide */.E6, {
              customClasses: {
                root: "btn-bg"
              },
              fileSrc: uniProfileData === null || uniProfileData === void 0 ? void 0 : (_uniProfileData$docum = uniProfileData.documentInfo) === null || _uniProfileData$docum === void 0 ? void 0 : _uniProfileData$docum.documentSrc,
              documentId: uniProfileData === null || uniProfileData === void 0 ? void 0 : (_uniProfileData$docum2 = uniProfileData.documentInfo) === null || _uniProfileData$docum2 === void 0 ? void 0 : _uniProfileData$docum2.documentId,
              documentType: "prospectus",
              universityId: parseInt(uniProfileData.universityId)
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      open: modal,
      onClose: function onClose() {
        setModal(false);
      },
      closeAfterTransition: true,
      BackdropComponent: Backdrop/* default */.Z,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "modal md",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "modal_head ".concat((uni_brief_module_default()).modal_header),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: "".concat((uni_brief_module_default()).title, " modal_title")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "cross_icon ".concat((uni_brief_module_default()).cross_action),
            onClick: function onClick() {
              setModal(false);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiX */.q5L, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((uni_brief_module_default()).modal_body, " modal_body"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: (uni_brief_module_default()).modal_title,
            children: "Write a Review"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (uni_brief_module_default()).modal_description,
            children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim odio dui, felis ultricies. Scelerisque quam tristique faucibus cras. Malesuada lobortis habitasse et enim vitae lectus tellus. Et volutpat hendrerit iaculis non in adipiscing tincidunt ut."
          }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).action_btn,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                setValue(0);
              },
              className: value === 0 && (uni_brief_module_default()).active_btn,
              children: "Guest User"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                setValue(1);
              },
              className: value === 1 && (uni_brief_module_default()).active_btn,
              children: "Register User"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewOption, {
            setModal: setModal,
            uniProfileData: uniProfileData,
            value: value,
            getData: getData,
            existingComment: existingComment,
            onEdit: onEdit,
            getComment: getComment
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ var uni_brief = ((/* unused pure expression or super */ null && (UniBrief)));
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_modules/study/university/uni_links.module.scss
var uni_links_module = __webpack_require__(13777);
var uni_links_module_default = /*#__PURE__*/__webpack_require__.n(uni_links_module);
// EXTERNAL MODULE: ./node_modules/country-data/index.js
var country_data = __webpack_require__(3023);
;// CONCATENATED MODULE: ./_modules/study/university/uni_links.jsx













var UniLinks = function UniLinks(props) {
  var _props$uniProfileData, _systemInfo$visitor_c, _systemInfo$visitor_c2, _props$uniProfileData2, _systemInfo$visitor_c3, _systemInfo$visitor_c4, _systemInfo$visitor_c5, _props$uniProfileData3, _props$uniProfileData4, _props$uniProfileData5, _props$uniProfileData6;

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath,
      query = router.query;
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var systemInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* systemAtom */.K2);

  var _useState = (0,react.useState)({}),
      menuStatus = _useState[0],
      setMenuStatus = _useState[1];

  var coursesLevelPageLink;
  var overviewPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name);
  var admissionFaqPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/admission-faq");
  var rankingPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/ranking");
  var coursesPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses");
  query.course_level ? coursesLevelPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses/").concat(query.course_level) : "";
  var searchCoursePageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/search-courses");
  var scholarshipsPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships");
  var scholarshipDetailsPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships/").concat(query.scholarship_slug);
  var blogPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/blog");
  var staffPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/staff");
  var eventFairPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/event-fair");
  var galleryPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/gallery");
  var reviewPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/reviews");
  var contactPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/contact");

  var getIpInof = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var default_country, _countries$default_co, _countries$default_co2, _countries$default_co4, _countries$default_co5, _countries$default_co3;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              default_country = localStorage.getItem("default_country");

              if (default_country && default_country != "") {
                //set visitor default courrencies
                if ((!(systemInfo !== null && systemInfo !== void 0 && systemInfo.currency) || (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency) == "") && (_countries$default_co = country_data/* countries */.hW[default_country.toUpperCase()]) !== null && _countries$default_co !== void 0 && _countries$default_co.currencies[0] && ((_countries$default_co2 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co2 === void 0 ? void 0 : _countries$default_co2.currencies[0]) != "") {
                  systemActions.setSystemCurrency((_countries$default_co3 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co3 === void 0 ? void 0 : _countries$default_co3.currencies[0]);
                } //set visitor countries


                if ((!(systemInfo !== null && systemInfo !== void 0 && systemInfo.visitor_country) || Object.keys(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.visitor_country).length === 0) && (_countries$default_co4 = country_data/* countries */.hW[default_country.toUpperCase()]) !== null && _countries$default_co4 !== void 0 && _countries$default_co4.name && ((_countries$default_co5 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co5 === void 0 ? void 0 : _countries$default_co5.name) != "") {
                  systemActions.setVisitorCountry(country_data/* countries */.hW[default_country.toUpperCase()]);
                }
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getIpInof() {
      return _ref.apply(this, arguments);
    };
  }(); //get IP Info


  (0,react.useEffect)(function () {
    getIpInof();
  }, []);
  (0,react.useEffect)(function () {
    function getMenuStatius() {
      return _getMenuStatius.apply(this, arguments);
    }

    function _getMenuStatius() {
      _getMenuStatius = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api/* default.get */.Z.get("/public/university/menu-status/".concat(query.university_name)).then(function (resp) {
                  if (!resp.error && resp.data) {
                    setMenuStatus(resp.data);
                  } else {
                    setMenuStatus({});
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getMenuStatius.apply(this, arguments);
    }

    getMenuStatius();
  }, [query.university_name]); // set system currency

  var setSystemCurrency = function setSystemCurrency(e) {
    systemActions.setSystemCurrency(e.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (uni_links_module_default()).section_links,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (uni_links_module_default()).links_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_links_module_default()).links_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: (uni_links_module_default()).link_lists,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: overviewPageLink,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === overviewPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Overview"
                })
              })
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.faq && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.faq) === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(admissionFaqPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === admissionFaqPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Admission FAQ"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.ranking && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.ranking) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(rankingPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === rankingPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Rankings"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.course && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.course) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(coursesPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath.split("?")[0] == coursesPageLink || coursesLevelPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Courses"
                })
              })
            }) : "", query.course_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(coursesPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(query.course_slug ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Course Details"
                })
              })
            }), asPath.includes("search-courses") && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Search Courses"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.sholarship && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.sholarship) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(scholarshipsPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === scholarshipsPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Scholarships"
                })
              })
            }) : "", query.scholarship_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Scholarship Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.blog && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.blog) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(blogPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === blogPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Blog"
                })
              })
            }) : "", query.uni_blog_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Blog Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.staff && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.staff) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(staffPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === staffPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Staff"
                })
              })
            }) : "", query.staff_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Staff Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.eventFair && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.eventFair) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(eventFairPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === eventFairPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Event/Fair"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.gallery && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.gallery) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(galleryPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === galleryPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Gallery"
                })
              })
            }) : "", query.slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Gallery Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.review && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.review) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(reviewPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === reviewPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Reviews"
                })
              })
            }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(contactPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === contactPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Contact"
                })
              })
            }), query.course_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
                name: "currencyCode",
                id: "currencyCode",
                className: (uni_links_module_default()).currencyChanger,
                onChange: setSystemCurrency,
                disabled: systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.loading,
                value: systemInfo !== null && systemInfo !== void 0 && systemInfo.currency && (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency) != "" ? systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency : props === null || props === void 0 ? void 0 : (_props$uniProfileData = props.uniProfileData) === null || _props$uniProfileData === void 0 ? void 0 : _props$uniProfileData.countryCurrency,
                children: systemInfo !== null && systemInfo !== void 0 && systemInfo.loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                  value: "",
                  children: " Loading "
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                  children: [(systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c = systemInfo.visitor_country) === null || _systemInfo$visitor_c === void 0 ? void 0 : _systemInfo$visitor_c.currencies) && (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c2 = systemInfo.visitor_country) === null || _systemInfo$visitor_c2 === void 0 ? void 0 : _systemInfo$visitor_c2.currencies[0].toUpperCase()) != (props === null || props === void 0 ? void 0 : (_props$uniProfileData2 = props.uniProfileData) === null || _props$uniProfileData2 === void 0 ? void 0 : _props$uniProfileData2.countryCurrency.toUpperCase()) && (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c3 = systemInfo.visitor_country) === null || _systemInfo$visitor_c3 === void 0 ? void 0 : _systemInfo$visitor_c3.currencies[0].toUpperCase()) != "USD" && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c4 = systemInfo.visitor_country) === null || _systemInfo$visitor_c4 === void 0 ? void 0 : _systemInfo$visitor_c4.currencies[0].toUpperCase(),
                    children: systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c5 = systemInfo.visitor_country) === null || _systemInfo$visitor_c5 === void 0 ? void 0 : _systemInfo$visitor_c5.currencies[0].toUpperCase()
                  }), (props === null || props === void 0 ? void 0 : (_props$uniProfileData3 = props.uniProfileData) === null || _props$uniProfileData3 === void 0 ? void 0 : _props$uniProfileData3.countryCurrency) && (props === null || props === void 0 ? void 0 : (_props$uniProfileData4 = props.uniProfileData) === null || _props$uniProfileData4 === void 0 ? void 0 : _props$uniProfileData4.countryCurrency) != "USD" && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: props === null || props === void 0 ? void 0 : (_props$uniProfileData5 = props.uniProfileData) === null || _props$uniProfileData5 === void 0 ? void 0 : _props$uniProfileData5.countryCurrency,
                    children: props === null || props === void 0 ? void 0 : (_props$uniProfileData6 = props.uniProfileData) === null || _props$uniProfileData6 === void 0 ? void 0 : _props$uniProfileData6.countryCurrency
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: "USD",
                    children: "USD"
                  })]
                })
              })
            })]
          })
        })
      })
    })
  });
};
/* harmony default export */ var uni_links = ((/* unused pure expression or super */ null && (UniLinks)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_wrapper.module.scss
var uni_profile_wrapper_module = __webpack_require__(98281);
var uni_profile_wrapper_module_default = /*#__PURE__*/__webpack_require__.n(uni_profile_wrapper_module);
// EXTERNAL MODULE: ./_hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(14418);
;// CONCATENATED MODULE: ./_modules/study/university/uni_profile_wrapper.jsx

var _excluded = ["isVideoBanner", "isBanner", "isBreadcrumb", "breadcrumbTitle", "children"];










var UniProfileWrapper = function UniProfileWrapper(_ref) {
  var _ref$isVideoBanner = _ref.isVideoBanner,
      isVideoBanner = _ref$isVideoBanner === void 0 ? true : _ref$isVideoBanner,
      _ref$isBanner = _ref.isBanner,
      isBanner = _ref$isBanner === void 0 ? true : _ref$isBanner,
      _ref$isBreadcrumb = _ref.isBreadcrumb,
      isBreadcrumb = _ref$isBreadcrumb === void 0 ? true : _ref$isBreadcrumb,
      breadcrumbTitle = _ref.breadcrumbTitle,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var uniProfileData = props.uniProfileData;

  var _useWindowDimensions = (0,useWindowDimensions/* default */.Z)(),
      width = _useWindowDimensions.width;

  var router = (0,next_router.useRouter)();
  var query = router.query,
      pathname = router.pathname;
  var targetPathSlug = pathname.split("/")[5];
  var course_slug = query.course_slug;

  var breadCrumbActiveLink = function breadCrumbActiveLink() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "color-orange",
      children: breadcrumbTitle ? breadcrumbTitle : (0,helpers/* generateNavTitle */.He)(targetPathSlug)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [isBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.videoType && isVideoBanner ? /*#__PURE__*/(0,jsx_runtime.jsx)(UniHeroWithVideo, {
        uniProfileData: uniProfileData
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(uni_profile_banner/* UniProfileBanner */.q, {
        uniProfileData: uniProfileData
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniBrief, {
      uniProfileData: uniProfileData,
      customClasses: {
        root: !isBanner ? (uni_profile_wrapper_module_default()).root : ""
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniLinks, {
      uniProfileData: uniProfileData
    }), (isBanner || width < 992) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (uni_profile_wrapper_module_default()).uni_breacrumbs,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: "Home"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
        href: "/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.countrySlug, "/university"),
        children: ["Universities in ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.CountryName]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/study/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.countrySlug, "/university/").concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug),
        children: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityName
      }), targetPathSlug && breadCrumbActiveLink()]
    }), children]
  });
};
/* harmony default export */ var uni_profile_wrapper = ((/* unused pure expression or super */ null && (UniProfileWrapper)));
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_banner.jsx
var uni_profile_banner = __webpack_require__(69805);
;// CONCATENATED MODULE: ./_modules/study/university/index.js






/***/ }),

/***/ 69805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ UniProfileBanner; }
/* harmony export */ });
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98576);
/* harmony import */ var _uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var UniProfileBanner = function UniProfileBanner(_ref) {
  var uniProfileData = _ref.uniProfileData;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("section", {
    className: (_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section_banner),
    children: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.featureSrc) &&
    /*#__PURE__*/
    // <div className={styles.banner_wrapper}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        layout: "responsive",
        width: 1905,
        height: 450,
        blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        placeholder: "blur",
        className: (_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner_image),
        src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.featureSrc) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        alt: "Video Background"
      })
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileBanner)));

/***/ }),

/***/ 17171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28719);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88740);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, base), {}, (_objectSpread2 = {
      height: "60px",
      boxShadow: state.isFocused ? "0px 4px 15px rgba(244, 127, 32, 0.15)" : "none",
      borderColor: "#eeeeee",
      "&:hover": {
        borderColor: "#eeeeee"
      }
    }, (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "borderColor", state.isFocused ? "#F47F20" : "#eeeeee"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "backgroundColor", "#fff"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "fontSize", "13px"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "borderRadius", "8px"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "padding", "0 20px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      cursor: "pointer",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      fontSize: "13px",
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuPortal: function menuPortal(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: 9999
    });
  }
};
var init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "guest",
  reviewerName: "",
  reviewerEmail: "",
  reviewComment: "",
  reviewerPhone: "",
  reviewerCountryId: undefined
};

var GuestFormReview = function GuestFormReview(_ref) {
  var uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var asPath = router.asPath;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      lastName = _useState[0],
      setLastName = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      countryList = _useState2[0],
      setCountryList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(init),
      formData = _useState3[0],
      setFormData = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("in"),
      defaultCountryCode = _useState4[0],
      setDefaultCountryCode = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setTimeout(function () {
      if (js_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"].get */ .Z.get("default_country")) {
        setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"].get */ .Z.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]); // all country list

  var getCountryList = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/public/country/dropdown").then(function (res) {
                if (!res.error) {
                  setCountryList(res.data);
                } else {
                  setCountryList([]);
                }
              })["catch"](function (error) {
                setCountryList([]);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getCountryList() {
      return _ref2.apply(this, arguments);
    };
  }(); // fetch only country


  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    getCountryList();
  }, []); // validation schema

  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    rating: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Please give rating"),
    reviewerName: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewerEmail: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewerCountryId: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewComment: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required")
  });

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                universityId: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityId,
                rating: values.rating,
                reviewerType: "guest",
                reviewerName: "".concat(values.reviewerName, " ").concat(lastName),
                reviewerEmail: values.reviewerEmail,
                reviewComment: values.reviewComment,
                reviewerPhone: values.reviewerPhone,
                reviewerCountryId: values.reviewerCountryId
              };
              _context3.next = 3;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/public/university-review", payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 8;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .swalSuccess */ .Xt)("Submitted");
                          setModal(false);
                          _context2.next = 5;
                          return getData();

                        case 5:
                          router.push(asPath);
                          _context2.next = 9;
                          break;

                        case 8:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .swalError */ .Kj)(res === null || res === void 0 ? void 0 : res.message, "Sorry");

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmitForm(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrapper),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
      initialValues: formData,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values) {
        handleSubmitForm(values);
      },
      children: function children(_ref5) {
        var handleSubmit = _ref5.handleSubmit,
            setFieldValue = _ref5.setFieldValue,
            values = _ref5.values,
            errors = _ref5.errors,
            touched = _ref5.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
          className: "form",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().rating_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              sx: {
                fontSize: "50px"
              },
              value: values.rating,
              name: "rating",
              onChange: function onChange(event, newValue) {
                setFieldValue("rating", newValue);
              }
            }), errors.rating && touched.rating && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "invalid-feedback frontend",
              children: errors.rating
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "First Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  type: "text",
                  placeholder: "First Name",
                  onChange: function onChange(e) {
                    setFieldValue("reviewerName", e.target.value);
                  },
                  value: values.reviewerName
                })]
              }), errors.reviewerName && touched.reviewerName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerName
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Last Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  onChange: function onChange(e) {
                    setLastName(e.target.value);
                  },
                  type: "text",
                  placeholder: "Last Name"
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Email Address"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  type: "text",
                  placeholder: "Email Address",
                  name: "reviewerEmail",
                  onChange: function onChange(e) {
                    setFieldValue("reviewerEmail", e.target.value);
                  },
                  value: values.reviewerEmail
                })]
              }), errors.reviewerEmail && touched.reviewerEmail && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerEmail
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Phone Number"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default()), {
                  placeholder: "Phone Number",
                  country: defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : "in",
                  countryCodeEditable: false,
                  value: values.phone,
                  onChange: function onChange(_value, country, _event, formattedValue) {
                    setFieldValue("reviewerPhone", formattedValue);
                  },
                  className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().phoneInput)
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Country"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  id: "reviewerCountryId",
                  name: "reviewerCountryId",
                  placeholder: "Select Your Country",
                  options: countryList !== null && countryList !== void 0 ? countryList : [],
                  multi: false,
                  styles: customStyles,
                  onChange: function onChange(item) {
                    setFieldValue("reviewerCountryId", item.value);
                  },
                  value: countryList ? countryList.filter(function (item) {
                    return item.value == (values === null || values === void 0 ? void 0 : values.reviewerCountryId);
                  }) : {}
                })]
              }), errors.reviewerCountryId && touched.reviewerCountryId && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerCountryId
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 12,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text_input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Write Your Review"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("textarea", {
                  style: {
                    resize: "vertical"
                  },
                  name: "reviewComment",
                  onChange: function onChange(e) {
                    setFieldValue("reviewComment", e.target.value);
                  },
                  value: values.reviewComment,
                  type: "text",
                  placeholder: "Write Here"
                })]
              }), errors.reviewComment && touched.reviewComment && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewComment
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              sm: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().action_btn),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                  onClick: function onClick() {
                    return handleSubmit;
                  },
                  type: "submit",
                  className: "btn btn-secondary btn-md",
                  children: "Submit Review"
                })
              })
            })]
          })]
        });
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GuestFormReview);

/***/ }),

/***/ 25702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88740);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72145);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2804);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89093);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8612);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



/* eslint-disable react-hooks/exhaustive-deps */















var init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "registered",
  reviewComment: ""
};

var RegisterFormReview = function RegisterFormReview(_ref) {
  var uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      onEdit = _ref.onEdit,
      existingComment = _ref.existingComment,
      getComment = _ref.getComment;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
  var asPath = router.asPath;
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_7__/* .authAtom */ .L4);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(init),
      formData = _useState[0],
      setFormData = _useState[1];

  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_9__/* .useSystemActions */ .x3)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (onEdit) {
      setFormData({
        universityId: parseInt(existingComment === null || existingComment === void 0 ? void 0 : existingComment.universityId),
        rating: parseInt(existingComment === null || existingComment === void 0 ? void 0 : existingComment.rating),
        reviewerType: "registered",
        reviewComment: existingComment === null || existingComment === void 0 ? void 0 : existingComment.reviewComment
      });
    } else {
      setFormData(init);
    }
  }, [onEdit, existingComment]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    systemActions.removeReturnUrl();
  }, []); // validation schema

  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry().shape({
    rating: yup__WEBPACK_IMPORTED_MODULE_4__/* .number */ .Rx().required("Field is required"),
    reviewComment: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Field is required")
  });

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                universityId: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityId,
                rating: values.rating,
                reviewerType: "registered",
                reviewerId: profileInfo.id,
                reviewComment: values.reviewComment // reviewerName: `${profileInfo.firstName} ${profileInfo.middleName} ${profileInfo.lastName}`,
                // reviewerEmail: profileInfo.email,
                // reviewerPhone: profileInfo.mobile,
                // reviewerCountryId: profileInfo.countryId,

              };

              if (!onEdit) {
                _context3.next = 6;
                break;
              }

              _context3.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("/public/university-review/".concat(existingComment === null || existingComment === void 0 ? void 0 : existingComment.universityReviewId), payload).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (res.error) {
                            _context.next = 8;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__/* .swalSuccess */ .Xt)("Updated");
                          setModal(false);
                          _context.next = 5;
                          return getData();

                        case 5:
                          _context.next = 7;
                          return getComment();

                        case 7:
                          router.push(asPath);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 4:
              _context3.next = 8;
              break;

            case 6:
              _context3.next = 8;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/public/university-review", payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 7;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__/* .swalSuccess */ .Xt)("Submitted");
                          setModal(false);
                          _context2.next = 5;
                          return getData();

                        case 5:
                          _context2.next = 7;
                          return getComment();

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getSign = /*#__PURE__*/function () {
    var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              systemActions.setReturnUrl(router.asPath);
              _context4.next = 3;
              return router.push({
                pathname: "/signin"
              });

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getSign() {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
    className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper),
    children: profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
      initialValues: formData,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values) {
        handleSubmitForm(values);
      },
      children: function children(_ref6) {
        var handleSubmit = _ref6.handleSubmit,
            setFieldValue = _ref6.setFieldValue,
            values = _ref6.values,
            errors = _ref6.errors,
            touched = _ref6.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
          className: "form",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rating_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
              sx: {
                fontSize: "50px",
                mt: 3
              },
              value: parseInt(values.rating),
              name: "rating",
              onChange: function onChange(event, newValue) {
                setFieldValue("rating", newValue);
              }
            }), errors.rating && touched.rating && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "invalid-feedback frontend",
              children: errors.rating
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
              item: true,
              md: 12,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("label", {
                  children: "Write your review"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("textarea", {
                  style: {
                    resize: "vertical"
                  },
                  name: "reviewComment",
                  onChange: function onChange(e) {
                    setFieldValue("reviewComment", e.target.value);
                  },
                  value: values.reviewComment,
                  type: "text",
                  placeholder: "Write Here"
                })]
              }), errors.reviewComment && touched.reviewComment && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewComment
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
              item: true,
              sm: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().action_btn),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                  onClick: function onClick() {
                    return handleSubmit;
                  },
                  type: "submit",
                  className: "btn btn-secondary btn-md",
                  children: onEdit ? "Update Review" : "Submit Review"
                })
              })
            })]
          })]
        });
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
      style: {
        width: "100%",
        marginTop: "20px"
      },
      onClick: getSign,
      className: "btn btn-secondary btn-bg",
      children: "Sign in"
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RegisterFormReview);

/***/ }),

/***/ 74155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E6": function() { return /* reexport */ DownloadGuide; },
  "qq": function() { return /* reexport */ MessageComponent; },
  "Dk": function() { return /* reexport */ PersonList; },
  "sk": function() { return /* reexport */ common_form/* UniEditorSmall */.sk; },
  "z9": function() { return /* reexport */ useIsMount; }
});

// UNUSED EXPORTS: DatePickerComponent, DateRangeComponent, Dropdown, Editor, ImageInput, MultipleFileInput, PersonProfile, TimePeriod, Title, UniEditor, UniEditorDefault, UniEditorMedium, UniSugessions

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/title.jsx




var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.heading,
    children: [title && /*#__PURE__*/_jsx("h3", {
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      children: subtitle
    })]
  });
};
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (Title)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/dropdown.jsx


var _excluded = (/* unused pure expression or super */ null && (["topLabel", "bottomLabel", "options", "placeholder", "className", "selectedValue", "inputId", "onChange", "register"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Dropdown = function Dropdown(_ref) {
  var topLabel = _ref.topLabel,
      bottomLabel = _ref.bottomLabel,
      options = _ref.options,
      placeholder = _ref.placeholder,
      className = _ref.className,
      selectedValue = _ref.selectedValue,
      inputId = _ref.inputId,
      _onChange = _ref.onChange,
      register = _ref.register,
      rest = _objectWithoutProperties(_ref, _excluded);

  // const [value, setValue] = useState("");
  // useEffect(() => {
  //   setValue(selectedValue);
  // }, [selectedValue]);
  // const handleChange = (e) => {
  //   const { label, value } = e;
  //   setValue(value);
  //   if (onChange) {
  //     onChange(e);
  //   }
  // };
  var customStyles = {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, _defineProperty({
        height: "50px",
        boxShadow: " 0px 2px 5px rgba(38, 51, 77, 0.03)",
        borderColor: "none",
        "&:hover": {
          borderColor: "none"
        }
      }, "borderColor", state.isFocused ? "#e0e0e0" : "#e0e0e0"));
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        cursor: "pointer",
        color: state.isSelected ? "#F47F20" : "#B5B5C3",
        backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
        "&:hover": {
          backgroundColor: "#F5F6FC",
          color: "#F47F20"
        }
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
  return /*#__PURE__*/_jsxs(FormControl, {
    fullWidth: true,
    children: [topLabel && /*#__PURE__*/_jsx("label", {
      className: topLabel === "transparent" && styles.transparent,
      children: topLabel
    }), /*#__PURE__*/_jsx(Select, _defineProperty({
      className: "".concat(styles.select_input, " ").concat(className),
      options: options,
      onChange: _onChange,
      placeholder: placeholder && placeholder,
      styles: customStyles
    }, "onChange", function onChange(val) {
      return _onChange(val.value);
    })), bottomLabel && /*#__PURE__*/_jsx("label", {
      children: bottomLabel
    })]
  });
};
/* harmony default export */ var dropdown = ((/* unused pure expression or super */ null && (Dropdown)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/useIsMount.jsx

var useIsMount = function useIsMount() {
  var isMountRef = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/index.js



// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-timeago/es6/index.js
var es6 = __webpack_require__(92042);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/person_list/list.module.scss
var list_module = __webpack_require__(6867);
var list_module_default = /*#__PURE__*/__webpack_require__.n(list_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_list/index.jsx



/* eslint-disable @next/next/no-img-element */

















var PersonList = function PersonList(_ref) {
  var _connectedUserList$so;

  var data = _ref.data,
      clickHandler = _ref.clickHandler,
      chatId = _ref.chatId,
      setCurrentChat = _ref.setCurrentChat,
      socket = _ref.socket,
      connectedUserList = _ref.connectedUserList,
      getConnectedUserList = _ref.getConnectedUserList,
      loading = _ref.loading,
      setLoading = _ref.setLoading,
      customClasses = _ref.customClasses,
      closeDrawer = _ref.closeDrawer;

  var _useState = (0,react.useState)(),
      activeProfile = _useState[0],
      setActiveProfile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      userList = _useState3[0],
      setUserList = _useState3[1];

  var router = (0,next_router.useRouter)(); // open chat box

  var handleClick = function handleClick(person) {
    if (clickHandler) clickHandler(person);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  }; // get university list to add into friend list


  var getUserList = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(keyword) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (keyword && keyword.length >= 2 && keyword != "") {
                setLoading(true);
                setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return api/* default.get */.Z.get("/chat-service/get-users/".concat(keyword)).then(function (res) {
                            if (!res.error) {
                              setUserList(res.data);
                              setLoading(false);
                            }
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 2000);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getUserList(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // add user into chat list


  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(payload) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return api/* default.post */.Z.post("/chat-service/add-user", {
                recieverId: parseInt((payload === null || payload === void 0 ? void 0 : payload.userTypeSlug) === "mentor" ? payload === null || payload === void 0 ? void 0 : payload.id : payload === null || payload === void 0 ? void 0 : payload.universityId),
                recieverType: payload === null || payload === void 0 ? void 0 : payload.userTypeSlug,
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(res) {
                  var _res$data;

                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (res.error) {
                            _context3.next = 7;
                            break;
                          }

                          handleClose();
                          _context3.next = 4;
                          return getConnectedUserList();

                        case 4:
                          setUserList([]);
                          setActiveProfile();
                          router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((list_module_default()).list_wrapper, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (list_module_default()).header_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "btn btn-sm btn-outline-grey ".concat((list_module_default()).btn_add_user),
          onClick: handleOpen,
          children: "New User"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {
          className: (list_module_default()).btn_close,
          onClick: closeDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
          onClick: handleOpen,
          className: "".concat((list_module_default()).btn_plus, " relative"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "uni-tooltip",
            children: "New User"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (list_module_default()).chatt_box_wrapper,
        children: connectedUserList && (connectedUserList === null || connectedUserList === void 0 ? void 0 : connectedUserList.length) > 0 && (connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$so = connectedUserList.sort(function (a, b) {
          var _b$recentMsg, _b$recentMsg$chat_ser, _a$recentMsg;

          return b === null || b === void 0 ? void 0 : (_b$recentMsg = b.recentMsg) === null || _b$recentMsg === void 0 ? void 0 : (_b$recentMsg$chat_ser = _b$recentMsg.chat_service_message_senderTime) === null || _b$recentMsg$chat_ser === void 0 ? void 0 : _b$recentMsg$chat_ser.localeCompare(a === null || a === void 0 ? void 0 : (_a$recentMsg = a.recentMsg) === null || _a$recentMsg === void 0 ? void 0 : _a$recentMsg.chat_service_message_senderTime);
        })) === null || _connectedUserList$so === void 0 ? void 0 : _connectedUserList$so.map(function (item, index) {
          var _item$receiver, _item$receiver$name, _item$receiver2, _item$receiver3, _item$receiver4, _item$receiver5, _item$receiver6, _item$recentMsg, _item$recentMsg2, _item$recentMsg3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClick(item);
              setCurrentChat(item === null || item === void 0 ? void 0 : item.receiver);
              setActiveProfile(item);

              if (closeDrawer) {
                closeDrawer();
              }
            },
            className: item && (item === null || item === void 0 ? void 0 : item.uid) == chatId ? (list_module_default()).active_chatt_box : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: (item === null || item === void 0 ? void 0 : (_item$receiver = item.receiver) === null || _item$receiver === void 0 ? void 0 : _item$receiver.userTypeSlug) === "university" ? {
                    objectFit: "contain"
                  } : {},
                  alt: (_item$receiver$name = item === null || item === void 0 ? void 0 : (_item$receiver2 = item.receiver) === null || _item$receiver2 === void 0 ? void 0 : _item$receiver2.name) !== null && _item$receiver$name !== void 0 ? _item$receiver$name : "",
                  src: item !== null && item !== void 0 && (_item$receiver3 = item.receiver) !== null && _item$receiver3 !== void 0 && _item$receiver3.media ? (item === null || item === void 0 ? void 0 : (_item$receiver4 = item.receiver) === null || _item$receiver4 === void 0 ? void 0 : _item$receiver4.media) === null ? (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png") : item === null || item === void 0 ? void 0 : (_item$receiver5 = item.receiver) === null || _item$receiver5 === void 0 ? void 0 : _item$receiver5.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (list_module_default()).chatt_msg,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    children: item === null || item === void 0 ? void 0 : (_item$receiver6 = item.receiver) === null || _item$receiver6 === void 0 ? void 0 : _item$receiver6.name
                  }), item !== null && item !== void 0 && item.recentMsg ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$recentMsg = item.recentMsg) === null || _item$recentMsg === void 0 ? void 0 : _item$recentMsg.chat_service_message_messages
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "You Are Connected"
                  })]
                }), (item === null || item === void 0 ? void 0 : (_item$recentMsg2 = item.recentMsg) === null || _item$recentMsg2 === void 0 ? void 0 : _item$recentMsg2.chat_service_message_createdAt) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (list_module_default()).time,
                  children: moment_default()(item === null || item === void 0 ? void 0 : (_item$recentMsg3 = item.recentMsg) === null || _item$recentMsg3 === void 0 ? void 0 : _item$recentMsg3.chat_service_message_senderTime).fromNow()
                })]
              })]
            })
          }, "plist_".concat(index, "_").concat(item.id));
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      sx: {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "600px",
            paddingRight: "2px"
          }
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
        children: ["Start a New Chat", /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: "absolute",
            right: 8,
            top: 12,
            color: function color(theme) {
              return theme.palette.grey[500];
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgClose */.Fk5, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        dividers: true,
        sx: {
          padding: "0",
          minHeight: "50vh",
          maxHeight: "50vh"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (list_module_default()).search_input_modal,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            autoFocus: true,
            onChange: function onChange(e) {
              getUserList(e.target.value);
            },
            type: "text",
            placeholder: "Search User"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSearch */.jRj, {
            className: (list_module_default()).search_icon,
            style: {
              fontSize: "20px"
            }
          })]
        }), userList && (userList === null || userList === void 0 ? void 0 : userList.length) > 0 && !loading && (userList === null || userList === void 0 ? void 0 : userList.map(function (item, i) {
          var _item$fullName;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              setActiveProfile(item);
            },
            className: activeProfile && activeProfile.email === item.email ? (list_module_default()).active_chatt_box_modal : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.mediaSrc ? item.mediaSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
                  alt: (_item$fullName = item.fullName) !== null && _item$fullName !== void 0 ? _item$fullName : ""
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).chatt_msg,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [(item === null || item === void 0 ? void 0 : item.fullName) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    style: {
                      textTransform: "capitalize"
                    },
                    children: item === null || item === void 0 ? void 0 : item.fullName
                  }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [item === null || item === void 0 ? void 0 : item.email, " (", item === null || item === void 0 ? void 0 : item.userTypeSlug, ")"]
                  })]
                })
              })]
            })
          }, "plist_".concat(i));
        })), loading && Array(6).fill().map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
              maxWidth: "100%",
              padding: "0 15px",
              margin: "-16px 0",
              boxShadow: "none"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
              avatar: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                variant: "circular",
                width: 40,
                height: 40
              }),
              title: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "80%",
                style: {
                  marginBottom: 6
                }
              }),
              subheader: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "40%"
              })
            })
          }, i);
        }), (userList === null || userList === void 0 ? void 0 : userList.length) === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (list_module_default()).no_found,
          children: "No User Found"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
        sx: {
          padding: "12px 20px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-cancel btn-md",
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleSubmit(activeProfile);
          },
          type: "submit",
          className: "btn btn-secondary btn-md",
          style: {
            minWidth: "82px"
          },
          children: "Add"
        })]
      })]
    })]
  });
};
/* harmony default export */ var person_list = ((/* unused pure expression or super */ null && (PersonList)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/tfi/index.esm.js
var tfi_index_esm = __webpack_require__(81873);
// EXTERNAL MODULE: ./node_modules/react-scroll-to-bottom/lib/esm/index.js + 56 modules
var esm = __webpack_require__(17352);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/message_component/message.module.scss
var message_module = __webpack_require__(42891);
var message_module_default = /*#__PURE__*/__webpack_require__.n(message_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/message_component/index.jsx




/* eslint-disable @next/next/no-img-element */













var MessageComponent = function MessageComponent(_ref) {
  var _messages$, _connectedUserList$fi6, _connectedUserList$fi7, _myMessages$replace;

  var profileInfo = _ref.profileInfo,
      messages = _ref.messages,
      setMessages = _ref.setMessages,
      scrolref = _ref.scrolref,
      _ref$currentChat = _ref.currentChat,
      currentChat = _ref$currentChat === void 0 ? (_messages$ = messages[0]) === null || _messages$ === void 0 ? void 0 : _messages$.receiver : _ref$currentChat,
      getConnectedUserList = _ref.getConnectedUserList,
      _ref$connectedUserLis = _ref.connectedUserList,
      connectedUserList = _ref$connectedUserLis === void 0 ? false : _ref$connectedUserLis,
      chatId = _ref.chatId,
      socket = _ref.socket,
      setArrivalMessage = _ref.setArrivalMessage,
      closeDrawer = _ref.closeDrawer,
      openDrawer = _ref.openDrawer;

  //message state
  var _useState = (0,react.useState)(""),
      myMessages = _useState[0],
      setMyMessages = _useState[1];

  var _useState2 = (0,react.useState)(""),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var addNewLineToTextArea = function addNewLineToTextArea() {
    var msg_text = myMessages + "\r\n";
    setMyMessages(msg_text);
  }; //when press enter send message


  var handleKeyPress = function handleKeyPress(e) {
    var _e$target$value, _e$target$value$repla;

    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      addNewLineToTextArea();
    } else if (e.keyCode === 13 && ((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : (_e$target$value$repla = _e$target$value.replace(/\s/g, "")) === null || _e$target$value$repla === void 0 ? void 0 : _e$target$value$repla.length) >= 1 && !loading) {
      handleSubmitMessage();
    }
  }; // push new message


  var handleSubmitMessage = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _connectedUserList$fi, _connectedUserList$fi2;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return api/* default.post */.Z.post("/chat-service/new-meessage", {
                uid: chatId,
                messages: myMessages,
                recieverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi = connectedUserList.find(function (item) {
                  return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                })) === null || _connectedUserList$fi === void 0 ? void 0 : (_connectedUserList$fi2 = _connectedUserList$fi.receiver) === null || _connectedUserList$fi2 === void 0 ? void 0 : _connectedUserList$fi2.id,
                recieverType: "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
                  var _connectedUserList$fi3, _connectedUserList$fi4, _connectedUserList$fi5;

                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            setMyMessages("");
                            getConnectedUserList();
                            setMessages(function (prev) {
                              var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7, _res$data8, _res$data9, _res$data10, _res$data11, _res$data12;

                              return [].concat((0,toConsumableArray/* default */.Z)(prev), [{
                                id: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.id,
                                uid: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.uid,
                                studentId: (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.studentId,
                                senderType: (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.senderType,
                                universityId: (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.universityId,
                                university: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.university,
                                mentorId: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.mentorId,
                                mentor: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.mentor,
                                recieverType: (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.recieverType,
                                messages: (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.messages,
                                createdAt: (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.createdAt,
                                senderTime: res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.senderTime
                              }]);
                            });
                            setArrivalMessage(null);
                            socket.current.emit("send-message", {
                              senderId: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id,
                              receiverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi3 = connectedUserList.find(function (item) {
                                return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                              })) === null || _connectedUserList$fi3 === void 0 ? void 0 : (_connectedUserList$fi4 = _connectedUserList$fi3.receiver) === null || _connectedUserList$fi4 === void 0 ? void 0 : (_connectedUserList$fi5 = _connectedUserList$fi4.id) === null || _connectedUserList$fi5 === void 0 ? void 0 : _connectedUserList$fi5.toString(),
                              text: myMessages,
                              senderTime: new Date()
                            });
                            setLoading(false);
                          } else {
                            setLoading(false);
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmitMessage() {
      return _ref2.apply(this, arguments);
    };
  }(); // rendar message


  var RenderMessage = function RenderMessage(msgData) {
    var _msgData$receiver, _msgData$receiver2, _msgData$receiver3;

    if ((msgData === null || msgData === void 0 ? void 0 : msgData.is_first) == 1) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "chat_time",
        style: {
          fontSize: "13px"
        },
        children: msgData === null || msgData === void 0 ? void 0 : msgData.messages
      });
    } else if (msgData && (msgData === null || msgData === void 0 ? void 0 : msgData.studentId) === (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id) && (msgData === null || msgData === void 0 ? void 0 : msgData.senderType) === "student") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).my_msg_wrapper,
        children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (message_module_default()).my_msg_time,
          children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).my_msg,
          children: [(0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages), (msgData === null || msgData === void 0 ? void 0 : msgData.is_read) == 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneOutline */.xOC, {
            className: (message_module_default()).mark
          })]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).buddy_msg_wrapper,
      children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (message_module_default()).msg_time,
        children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).msg_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).image_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            style: (msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver = msgData.receiver) === null || _msgData$receiver === void 0 ? void 0 : _msgData$receiver.userTypeSlug) === "university" ? {
              objectFit: "contain"
            } : {},
            src: msgData !== null && msgData !== void 0 && (_msgData$receiver2 = msgData.receiver) !== null && _msgData$receiver2 !== void 0 && _msgData$receiver2.media ? msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver3 = msgData.receiver) === null || _msgData$receiver3 === void 0 ? void 0 : _msgData$receiver3.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
            alt: "avatar"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).replymsg,
          children: (0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages)
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (message_module_default()).message_component_wrapper,
    children: [currentChat && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tfi_index_esm/* TfiMenu */.lrj, {
        className: (message_module_default()).heading_menu,
        onClick: openDrawer
      }), connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi6 = connectedUserList.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
      })) === null || _connectedUserList$fi6 === void 0 ? void 0 : (_connectedUserList$fi7 = _connectedUserList$fi6.receiver) === null || _connectedUserList$fi7 === void 0 ? void 0 : _connectedUserList$fi7.name]
    }), messages && currentChat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.ZP, {
        className: (message_module_default()).conversation_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).conversation_wrapper_child,
          children: messages && (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && (messages === null || messages === void 0 ? void 0 : messages.map(function (msgData, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "chat_scroll",
              id: "chat_scroll",
              children: RenderMessage(msgData)
            }, (Math.random() + 1).toString(36).substring(7));
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (message_module_default()).msg_footer_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).action,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (message_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (message_module_default()).image_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                alt: "profile",
                src: profileInfo !== null && profileInfo !== void 0 && profileInfo.profileImageSrc ? profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.profileImageSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
              "aria-label": "minimum height",
              style: {
                minHeight: "40px"
              },
              placeholder: "Reply Message...",
              value: myMessages !== null && myMessages !== void 0 ? myMessages : "",
              onChange: function onChange(e) {
                setMyMessages(e.target.value);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.key === "Enter") {
                  e.preventDefault();
                }

                handleKeyPress(e);
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (message_module_default()).action_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
              disabled: (myMessages === null || myMessages === void 0 ? void 0 : (_myMessages$replace = myMessages.replace(/\s/g, "")) === null || _myMessages$replace === void 0 ? void 0 : _myMessages$replace.length) >= 1 ? false : true,
              onClick: handleSubmitMessage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSend */.D6S, {})
            })
          })]
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (message_module_default()).details_wrapper2,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).empty_detail_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Select a chat or start a new conversation"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: openDrawer,
          className: "btn btn-outline-grey btn-sm",
          children: "Start"
        })]
      })
    })]
  });
};
/* harmony default export */ var message_component = ((/* unused pure expression or super */ null && (MessageComponent)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_profile/index.jsx




var person_profile_excluded = (/* unused pure expression or super */ null && (["data", "profileType"]));


function person_profile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function person_profile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? person_profile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : person_profile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, (_objectSpread2 = {
      minHeight: "46px",
      boxShadow: state.isFocused ? "none" : "none",
      borderColor: "none",
      "&:hover": {
        borderColor: "none"
      }
    }, (0,defineProperty/* default */.Z)(_objectSpread2, "borderColor", state.isFocused ? "#f5f8fa" : "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "backgroundColor", "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "fontSize", "14px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return person_profile_objectSpread(person_profile_objectSpread({}, provided), {}, {
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.3s",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuList: function menuList(base) {
    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, {
      "::-webkit-scrollbar": {
        width: "5px",
        height: "6px",
        overflow: "visible",
        cursor: "pointer",
        background: "transparent",
        borderRadius: "10px"
      },
      "::-webkit-scrollbar-thumb": {
        background: "rgb(202, 202, 202)",
        borderRadius: "10px",
        cursor: "pointer"
      }
    });
  }
};
var PersonProfile = function PersonProfile(_ref) {
  var _data$name, _profileInfo$workingC, _profileInfo$preferen, _profileInfo$preferen2, _profileInfo$preferen3, _profileInfo$preferen4, _profileInfo$preferen5, _profileInfo$preferen6, _profileInfo$preferen7, _profileInfo$preferen8, _profileInfo$preferen9, _profileInfo$preferen10, _profileInfo$preferen11, _profileInfo$preferen12, _profileInfo$preferen13, _profileInfo$preferen14, _profileInfo$preferen15, _profileInfo$preferen16, _profileInfo$preferen17, _profileInfo$preferen18, _profileInfo$preferen19, _profileInfo$preferen20, _profileInfo$preferen21, _profileInfo$preferen22, _profileInfo$preferen23, _profileInfo$preferen24, _profileInfo$preferen25, _profileInfo$preferen26, _profileInfo$preferen27, _profileInfo$preferen28, _profileInfo$preferen29, _profileInfo$preferen30, _profileInfo$preferen31, _profileInfo$preferen32, _profileInfo$preferen33, _profileInfo$preferen34, _profileInfo$preferen35, _profileInfo$preferen36, _profileInfo$preferen37, _profileInfo$preferen38;

  var data = _ref.data,
      profileType = _ref.profileType,
      props = _objectWithoutProperties(_ref, person_profile_excluded);

  var tZone = getTimeZone();

  var _React$useState = React.useState(new Date()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _useState = useState(moment.tz.guess()),
      currentTzone = _useState[0],
      setCurrentTzone = _useState[1];

  var _useState2 = useState(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      showInMobile = _useState3[0],
      setShowInMobile = _useState3[1];

  var _useState4 = useState(),
      timeSlot = _useState4[0],
      setTimeslot = _useState4[1];

  var _useState5 = useState({}),
      profileInfo = _useState5[0],
      setProfileInfo = _useState5[1];

  var _useState6 = useState(),
      index = _useState6[0],
      setIndex = _useState6[1];

  var getProfile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return API.get("/user/any-profile?userType=".concat(profileType, "&id=").concat(data === null || data === void 0 ? void 0 : data.id)).then(function (res) {
                if (!res.error) {
                  setProfileInfo(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProfile() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && profileType) {
      getProfile();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, profileType]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                date: value,
                counsellorId: data === null || data === void 0 ? void 0 : data.id,
                timezone: currentTzone
              };
              _context2.next = 3;
              return API.post("/student/counsellor-appointment/time-list", payload).then(function (res) {
                if (!res.error) {
                  setTimeslot(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && value && currentTzone && profileType === "counsellor") {
      handleSubmit();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, value, currentTzone, profileType]);

  function formatAMPM(time) {
    // return time;
    var hour = time.split(":");
    var hrs = parseInt(hour[0]);
    var ampm = hrs >= 12 ? "pm" : "am";
    hrs = hrs % 12;
    hrs = hrs ? hrs : 12; // the hour '0' should be '12'

    var strTime = hrs + ":" + hour[1] + " " + ampm;
    return strTime;
  }

  var handleOpen = function handleOpen() {
    setOpen(true);
    document.body.classList.add("popOpen");
    handleSubmit();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    document.body.classList.remove("popOpen");
    setIndex();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.profile_wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image_wrapper,
      children: /*#__PURE__*/_jsx("img", {
        src: data.profileImage ? data.profileImage : getAssets("assets/student-avatar-big.png"),
        alt: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : ""
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: data.name
    }), profileType && profileType == "counsellor" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.profile_bio,
        children: [profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && htmlParse(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio), profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && /*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "/app/student/counsellor/".concat(data === null || data === void 0 ? void 0 : data.id),
          children: /*#__PURE__*/_jsx("a", {
            className: styles.read_more,
            children: "Read More"
          })
        })]
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && /*#__PURE__*/_jsx("h5", {
        children: "Working Country"
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$workingC = profileInfo.workingCountry) === null || _profileInfo$workingC === void 0 ? void 0 : _profileInfo$workingC.length) > 0 && /*#__PURE__*/_jsx("div", {
        className: styles.country_wrapper,
        children: profileInfo.workingCountry && profileInfo.workingCountry.map(function (item, i) {
          return /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: item
          }, i);
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: handleOpen,
        className: "btn btn-primary ".concat(styles.book_appiontment),
        children: "Book Appointment"
      })]
    }), profileType && profileType == "student" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen = profileInfo.preferences) === null || _profileInfo$preferen === void 0 ? void 0 : _profileInfo$preferen.courselevel) && /*#__PURE__*/_jsx("h5", {
          children: "Course Level"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen2 = profileInfo.preferences) === null || _profileInfo$preferen2 === void 0 ? void 0 : (_profileInfo$preferen3 = _profileInfo$preferen2.courselevel) === null || _profileInfo$preferen3 === void 0 ? void 0 : _profileInfo$preferen3.levelName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen4 = profileInfo.preferences) === null || _profileInfo$preferen4 === void 0 ? void 0 : (_profileInfo$preferen5 = _profileInfo$preferen4.courselevel) === null || _profileInfo$preferen5 === void 0 ? void 0 : _profileInfo$preferen5.levelName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen6 = profileInfo.preferences) === null || _profileInfo$preferen6 === void 0 ? void 0 : _profileInfo$preferen6.countryPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Country Preferences"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen7 = profileInfo.preferences) === null || _profileInfo$preferen7 === void 0 ? void 0 : _profileInfo$preferen7.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen8 = profileInfo.preferences) === null || _profileInfo$preferen8 === void 0 ? void 0 : (_profileInfo$preferen9 = _profileInfo$preferen8.countryPreferences) === null || _profileInfo$preferen9 === void 0 ? void 0 : _profileInfo$preferen9.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen10 = profileInfo.preferences) === null || _profileInfo$preferen10 === void 0 ? void 0 : _profileInfo$preferen10.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen11 = profileInfo.preferences) === null || _profileInfo$preferen11 === void 0 ? void 0 : (_profileInfo$preferen12 = _profileInfo$preferen11.countryPreferences) === null || _profileInfo$preferen12 === void 0 ? void 0 : _profileInfo$preferen12.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen13 = profileInfo.preferences) === null || _profileInfo$preferen13 === void 0 ? void 0 : _profileInfo$preferen13.studyPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Preferred Courses"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen14 = profileInfo.preferences) === null || _profileInfo$preferen14 === void 0 ? void 0 : _profileInfo$preferen14.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen15 = profileInfo.preferences) === null || _profileInfo$preferen15 === void 0 ? void 0 : (_profileInfo$preferen16 = _profileInfo$preferen15.studyPreferences) === null || _profileInfo$preferen16 === void 0 ? void 0 : _profileInfo$preferen16.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen17 = profileInfo.preferences) === null || _profileInfo$preferen17 === void 0 ? void 0 : _profileInfo$preferen17.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen18 = profileInfo.preferences) === null || _profileInfo$preferen18 === void 0 ? void 0 : (_profileInfo$preferen19 = _profileInfo$preferen18.studyPreferences) === null || _profileInfo$preferen19 === void 0 ? void 0 : _profileInfo$preferen19.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen20 = profileInfo.preferences) === null || _profileInfo$preferen20 === void 0 ? void 0 : _profileInfo$preferen20.specialization) && /*#__PURE__*/_jsx("h5", {
          children: "Specialization"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen21 = profileInfo.preferences) === null || _profileInfo$preferen21 === void 0 ? void 0 : (_profileInfo$preferen22 = _profileInfo$preferen21.specialization) === null || _profileInfo$preferen22 === void 0 ? void 0 : _profileInfo$preferen22.specializationName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen23 = profileInfo.preferences) === null || _profileInfo$preferen23 === void 0 ? void 0 : (_profileInfo$preferen24 = _profileInfo$preferen23.specialization) === null || _profileInfo$preferen24 === void 0 ? void 0 : _profileInfo$preferen24.specializationName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen25 = profileInfo.preferences) === null || _profileInfo$preferen25 === void 0 ? void 0 : _profileInfo$preferen25.intakePreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Intake"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen26 = profileInfo.preferences) === null || _profileInfo$preferen26 === void 0 ? void 0 : _profileInfo$preferen26.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen27 = profileInfo.preferences) === null || _profileInfo$preferen27 === void 0 ? void 0 : (_profileInfo$preferen28 = _profileInfo$preferen27.intakePreferences) === null || _profileInfo$preferen28 === void 0 ? void 0 : _profileInfo$preferen28.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen29 = profileInfo.preferences) === null || _profileInfo$preferen29 === void 0 ? void 0 : _profileInfo$preferen29.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen30 = profileInfo.preferences) === null || _profileInfo$preferen30 === void 0 ? void 0 : (_profileInfo$preferen31 = _profileInfo$preferen30.intakePreferences) === null || _profileInfo$preferen31 === void 0 ? void 0 : _profileInfo$preferen31.map(function (item, i) {
            var year = item.year,
                data = item.data;
            var last = Object.keys(data).length - 1;
            var payload = {
              year: year,
              from: data[Object.keys(data)[0]],
              to: data[Object.keys(data)[last]]
            };
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: "".concat(payload.from, "-").concat(payload.to, ", ").concat(payload.year)
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen32 = profileInfo.preferences) === null || _profileInfo$preferen32 === void 0 ? void 0 : _profileInfo$preferen32.budget) && /*#__PURE__*/_jsx("h5", {
          children: "Budget"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen33 = profileInfo.preferences) === null || _profileInfo$preferen33 === void 0 ? void 0 : _profileInfo$preferen33.budget) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen34 = profileInfo.preferences) === null || _profileInfo$preferen34 === void 0 ? void 0 : _profileInfo$preferen34.budget
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen35 = profileInfo.preferences) === null || _profileInfo$preferen35 === void 0 ? void 0 : _profileInfo$preferen35.objective) && /*#__PURE__*/_jsx("h5", {
          children: "Objective"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen36 = profileInfo.preferences) === null || _profileInfo$preferen36 === void 0 ? void 0 : _profileInfo$preferen36.objective) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen37 = profileInfo.preferences) === null || _profileInfo$preferen37 === void 0 ? void 0 : (_profileInfo$preferen38 = _profileInfo$preferen37.objective) === null || _profileInfo$preferen38 === void 0 ? void 0 : _profileInfo$preferen38.objectivePurpose
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "modal ".concat(styles.modal_custom_width),
        children: [/*#__PURE__*/_jsx("button", {
          className: "".concat(styles.cross_icon, " cross_icon"),
          onClick: handleClose,
          children: /*#__PURE__*/_jsx(FiX, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.appoint_modal,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.appoint_modal_right,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.appoint_title,
              children: "Select a Date & Time"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.appoint_calender_and_time_wrapper,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.calender_and_time_zone_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    maxHeight: "310px"
                  },
                  children: /*#__PURE__*/_jsx(LocalizationProvider, {
                    dateAdapter: AdapterDateFns,
                    children: /*#__PURE__*/_jsx(StaticDatePicker, {
                      className: "appointModalDatePicker",
                      displayStaticWrapperAs: "desktop",
                      openTo: "day",
                      minDate: new Date(),
                      value: value,
                      onChange: function onChange(newValue) {
                        setValue(newValue);
                        setShowInMobile(true);
                        setIndex();
                      },
                      renderInput: function renderInput(params) {
                        return /*#__PURE__*/_jsx(TextField, person_profile_objectSpread({}, params));
                      }
                    })
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.time_zone_wrapper,
                  children: [/*#__PURE__*/_jsx("label", {
                    className: styles.label,
                    children: "Select Time Zone"
                  }), /*#__PURE__*/_jsx(Select, {
                    menuPlacement: "top",
                    placeholder: "Select Timezone",
                    styles: customStyles,
                    options: tZone,
                    value: currentTzone && tZone ? tZone.filter(function (tz) {
                      return tz.value == currentTzone;
                    }) : "",
                    onChange: function onChange(item) {
                      setCurrentTzone(item.value);
                      setIndex();
                    }
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.appoint_time_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.back_icon_and_date_wrapper,
                  children: [/*#__PURE__*/_jsx(IconButton, {
                    onClick: function onClick() {
                      return setShowInMobile(false);
                    },
                    className: styles.back_btn,
                    children: /*#__PURE__*/_jsx(ArrowBackIcon, {})
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.appoint_time_title,
                    children: new Date(value).toDateString()
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.appoint_time_list_wrapper,
                  children: /*#__PURE__*/_jsx("ul", {
                    children: timeSlot && timeSlot.length > 0 ? timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.map(function (item, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsxs("button", {
                          onClick: function onClick() {
                            return setIndex(i);
                          },
                          className: "".concat(styles.appoint_time_btn, " ").concat(index === i ? styles.active : ""),
                          children: [formatAMPM(item === null || item === void 0 ? void 0 : item.startTime), "-", formatAMPM(item === null || item === void 0 ? void 0 : item.endTime)]
                        }), /*#__PURE__*/_jsx("button", {
                          className: "".concat(styles.confirm_btn, " ").concat(index === i ? styles.active : "", " btn btn-secondary btn-bg"),
                          onClick: function onClick() {
                            handleFormSubmit(item === null || item === void 0 ? void 0 : item.timeId);
                          },
                          children: "Confirm"
                        })]
                      }, i);
                    }) : /*#__PURE__*/_jsx("li", {
                      className: styles.no_record,
                      children: "\"No Appoinment Schedule\""
                    })
                  })
                })]
              })]
            })]
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var person_profile = ((/* unused pure expression or super */ null && (PersonProfile)));
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/index.js



// EXTERNAL MODULE: ./_unisearch/common/form/index.js + 15 modules
var common_form = __webpack_require__(15603);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./_unisearch/common/download_guide/index.jsx


var download_guide_excluded = ["fileSrc", "btnTitle", "fileName", "documentType", "customClasses", "customStyles", "universityId", "documentId"];











/*
documentType -> 'prospectus', 'exam', 'document', 'course', 'ebook', 'countryguide'

This componetn takes props
-> fileSrc
-> fileName
-> btnTitle
-> documentType
-> universityId
-> documentId
-> customClasses={
        root.[your class name]
    }
-> customClasses={
        title.[your class name]
   }
-> customClasses={
        tooltip.[your class name]
    }
-> customStyles={{ root: { color: "blue" } }}
-> customStyles={{ title: { fontSize: "30px" } }}
-> customStyles={{ tooltip: { color: "blue" } }}
 */



var DownloadGuide = function DownloadGuide(_ref) {
  var fileSrc = _ref.fileSrc,
      btnTitle = _ref.btnTitle,
      fileName = _ref.fileName,
      _ref$documentType = _ref.documentType,
      documentType = _ref$documentType === void 0 ? "prospectus" : _ref$documentType,
      customClasses = _ref.customClasses,
      customStyles = _ref.customStyles,
      _ref$universityId = _ref.universityId,
      universityId = _ref$universityId === void 0 ? 0 : _ref$universityId,
      _ref$documentId = _ref.documentId,
      documentId = _ref$documentId === void 0 ? 0 : _ref$documentId,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, download_guide_excluded);

  var router = (0,next_router.useRouter)();
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var profileInfos = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  (0,react.useEffect)(function () {
    setProfileInfo(profileInfos);
  }, []);

  var storeStudentDownloadInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api/* default.post */.Z.post("/student/download-activity", {
                universityId: universityId,
                type: documentType,
                mediaId: documentId
              }).then(function (res) {});

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              (0,helpers/* swalError */.Kj)("Something went wrong");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function storeStudentDownloadInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDownload = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(fileSrc) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (profileInfo) {
                _context2.next = 3;
                break;
              }

              systemActions.setReturnUrl(router.asPath);
              return _context2.abrupt("return", router.push({
                pathname: "/signin"
              }));

            case 3:
              if (profileInfo && profileInfo.userTypeSlug === "student") {
                storeStudentDownloadInfo();
              }

              window.open(fileSrc, "_blank");

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDownload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    onClick: function onClick() {
      handleDownload(fileSrc);
    },
    className: "btn btn-secondary relative ".concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPictureAsPdf */.OY_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.title ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.title : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.title,
      children: btnTitle || "Download Brochure"
    }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "uni-tooltip ".concat(customClasses !== null && customClasses !== void 0 && customClasses.tooltip ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.tooltip : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.tooltip,
      children: ["Please Login ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " to perform this action"]
    })]
  });
};
/* harmony default export */ var download_guide = ((/* unused pure expression or super */ null && (DownloadGuide)));
;// CONCATENATED MODULE: ./_unisearch/common/index.js





/***/ }),

/***/ 81032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ courses; }
});

// EXTERNAL MODULE: ./_modules/study/university/index.js + 4 modules
var university = __webpack_require__(97623);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_modules/study/common/course_card/index.jsx
var course_card = __webpack_require__(316);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 16 modules
var react_select_esm = __webpack_require__(28719);
// EXTERNAL MODULE: ./_modules/study/common/advance_search/advance/index.js + 3 modules
var advance = __webpack_require__(74681);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(51627);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SwipeableDrawer/SwipeableDrawer.js + 5 modules
var SwipeableDrawer = __webpack_require__(91707);
// EXTERNAL MODULE: ./_unisearch/common/ui_element/pagination/index.jsx
var pagination = __webpack_require__(59076);
// EXTERNAL MODULE: ./_unisearch/common/ui_element/pagination/components/show_paginate_text/index.jsx
var show_paginate_text = __webpack_require__(65842);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_unisearch/helpers/utils.js
var utils = __webpack_require__(90705);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/tb/index.esm.js
var tb_index_esm = __webpack_require__(37106);
// EXTERNAL MODULE: ./_hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(14418);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_modules/study/university/uni_filtered_courses/components/breadcrumb/breadcrumb.module.scss
var breadcrumb_module = __webpack_require__(92223);
var breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/university/uni_filtered_courses/components/breadcrumb/index.jsx






var Breadcrumb = function Breadcrumb(_ref) {
  var universityProfileData = _ref.universityProfileData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (breadcrumb_module_default()).breadcrumbs,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (breadcrumb_module_default()).link_area,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        className: (breadcrumb_module_default()).link,
        children: "Home \u203A"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
        href: "/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countrySlug, "/university"),
        className: (breadcrumb_module_default()).link,
        children: ["Universities in ", universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.CountryName, " \u203A"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
        className: (breadcrumb_module_default()).link,
        href: "/study/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countrySlug, "/university/").concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universitySlug),
        children: [universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " \u203A"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (breadcrumb_module_default()).link,
        children: "Courses"
      })]
    })
  });
};

/* harmony default export */ var breadcrumb = (Breadcrumb);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./_modules/study/university/uni_filtered_courses/components/card_layout_controller/card_layout.module.scss
var card_layout_module = __webpack_require__(66603);
var card_layout_module_default = /*#__PURE__*/__webpack_require__.n(card_layout_module);
;// CONCATENATED MODULE: ./_modules/study/university/uni_filtered_courses/components/card_layout_controller/index.jsx






var CardLayoutController = function CardLayoutController(_ref) {
  var setIsAlignRow = _ref.setIsAlignRow,
      isAlignRow = _ref.isAlignRow;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (card_layout_module_default()).grid_wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgMenu */.pLM, {
      style: {
        cursor: "pointer"
      },
      onClick: function onClick() {
        return setIsAlignRow(true);
      },
      className: "".concat(isAlignRow ? (card_layout_module_default()).active : (card_layout_module_default()).inActive),
      size: 25
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgMenuGridR */.owA, {
      style: {
        cursor: "pointer"
      },
      onClick: function onClick() {
        return setIsAlignRow(false);
      },
      size: 25,
      className: "".concat(!isAlignRow ? (card_layout_module_default()).active : (card_layout_module_default()).inActive)
    })]
  });
};

/* harmony default export */ var card_layout_controller = (CardLayoutController);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_modules/study/university/uni_filtered_courses/components/heading/heading.module.scss
var heading_module = __webpack_require__(71875);
var heading_module_default = /*#__PURE__*/__webpack_require__.n(heading_module);
;// CONCATENATED MODULE: ./_modules/study/university/uni_filtered_courses/components/heading/index.jsx







var HeadingCourse = function HeadingCourse(_ref) {
  var universityProfileData = _ref.universityProfileData,
      courseOverviewText = _ref.courseOverviewText;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (heading_module_default()).heading_wrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (heading_module_default()).heading,
      children: "All Courses"
    }), courseOverviewText ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: (0,helpers/* htmlParse */.QA)(courseOverviewText)
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: (heading_module_default()).short_description,
      children: ["Explore the courses", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
        children: [" ", universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName]
      }), " has to offer to find the right program for you!"]
    })]
  });
};

/* harmony default export */ var heading = (HeadingCourse);
// EXTERNAL MODULE: ./_modules/study/university/uni_filtered_courses/filtered_course.module.scss
var filtered_course_module = __webpack_require__(43375);
var filtered_course_module_default = /*#__PURE__*/__webpack_require__.n(filtered_course_module);
;// CONCATENATED MODULE: ./_modules/study/university/uni_filtered_courses/components/sorting/index.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var customStyles = {
  control: function control(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      height: "38px",
      // minWidth: "172px",
      width: "180px",
      fontSize: "14px",
      boxShadow: state.isFocused ? "0px 5.09687px 11.8927px rgba(150, 185, 255, 0.25)" : "0px 2px 5px rgba(38, 51, 77, 0.03)",
      borderColor: "#EEEEEE",
      "&:hover": {
        borderColor: "none"
      } // border style on hover

    });
  },
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      cursor: "pointer",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  }
};
var sortingOptions = [{
  value: "",
  label: "Default Sorting"
}, {
  value: "sbp",
  label: "Sort by Popularity"
}, {
  value: "sbtfLH",
  label: "Sort by Tution Frees Low to High"
}, {
  value: "sbtfHL",
  label: "Sort by Tution Frees High to Low"
}, {
  value: "sbr",
  label: "Sort by Rating"
}];
;// CONCATENATED MODULE: ./_modules/study/university/uni_filtered_courses/index.jsx




function uni_filtered_courses_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function uni_filtered_courses_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? uni_filtered_courses_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : uni_filtered_courses_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var showItemsData = [{
  id: 1,
  number: 8
}, {
  id: 2,
  number: 12
}, {
  id: 3,
  number: 16
}, {
  id: 4,
  number: 20
}];
var UniFilteredCourses = function UniFilteredCourses(_ref) {
  var _router$query, _router$query2, _router$query2$crl, _router$query3, _router$query4, _router$query4$sp, _router$query5, _router$query6, _router$query6$ex;

  var country_name = _ref.country_name,
      university_name = _ref.university_name,
      universityProfileData = _ref.universityProfileData,
      courseDurationData = _ref.courseDurationData,
      examsData = _ref.examsData,
      levelsData = _ref.levelsData,
      specializationsData = _ref.specializationsData,
      tutionFeeData = _ref.tutionFeeData,
      totalCoursesData = _ref.totalCoursesData,
      paginateData = _ref.paginateData,
      courseOverviewText = _ref.courseOverviewText;
  var router = (0,next_router.useRouter)();
  var query = router.query;

  var initPayload = uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({
    page: (query === null || query === void 0 ? void 0 : query.page) || 1,
    limit: (query === null || query === void 0 ? void 0 : query.limit) || 8
  }, router.query.crl && {
    crl: router.query.crl.split(",")
  }), router.query.sp && {
    sp: router.query.sp.split(",")
  }), router.query.ex && {
    ex: router.query.ex.split(",")
  }), router.query.duration && uni_filtered_courses_objectSpread({
    duration: router.query.duration.split(",")
  }, router.query.tfees && {
    tfees: router.query.tfees.split(",")
  })), router.query.sbp && {
    sbp: 1
  }), router.query.sbtfLH && {
    sbtfLH: 1
  }), router.query.sbtfHL && {
    sbtfHL: 1
  }), router.query.sbr && {
    sbr: 1
  });

  var defaultSortValue = {
    value: "",
    label: "Default Sorting"
  };

  if (router.query.sbp) {
    defaultSortValue.value = "sbp";
    defaultSortValue.label = "Sort by Popularity";
  }

  if (router.query.sbtfLH) {
    defaultSortValue.value = "sbtfLH";
    defaultSortValue.label = "Sort by Tution Frees Low to High";
  }

  if (router.query.sbtfHL) {
    defaultSortValue.value = "sbtfHL";
    defaultSortValue.label = "Sort by Tution Frees High to Low";
  }

  if (router.query.sbr) {
    defaultSortValue.value = "sbr";
    defaultSortValue.label = "Sort by Rating";
  }

  var _useState = (0,react.useState)(levelsData),
      levels = _useState[0],
      setLevels = _useState[1];

  var _useState2 = (0,react.useState)(examsData),
      exams = _useState2[0],
      setExams = _useState2[1];

  var _useState3 = (0,react.useState)(specializationsData),
      specializations = _useState3[0],
      setSpecializations = _useState3[1];

  var _useState4 = (0,react.useState)(courseDurationData),
      courseDuration = _useState4[0],
      setCourseDuration = _useState4[1];

  var _useState5 = (0,react.useState)(tutionFeeData),
      tutionFee = _useState5[0],
      setTutionFee = _useState5[1];

  var _useState6 = (0,react.useState)(totalCoursesData),
      totalCourses = _useState6[0],
      setTotalCourses = _useState6[1];

  var _useState7 = (0,react.useState)(paginateData),
      paginate = _useState7[0],
      setPaginate = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0,react.useState)(""),
      respError = _useState9[0],
      setRespError = _useState9[1];

  var _useState10 = (0,react.useState)(true),
      durationIsChangable = _useState10[0],
      setDurationIsChangable = _useState10[1];

  var _useState11 = (0,react.useState)(true),
      feeIsChangable = _useState11[0],
      setFeeIsChangable = _useState11[1];

  var _useState12 = (0,react.useState)(initPayload),
      payload = _useState12[0],
      setPayload = _useState12[1];

  var _useState13 = (0,react.useState)(query === null || query === void 0 ? void 0 : query.limit),
      showItem = _useState13[0],
      setShowItem = _useState13[1];

  var handlerShowItem = function handlerShowItem(number) {
    setPayload(function (prev) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prev), {}, {
        limit: number
      });
    });
  };

  var _useState14 = (0,react.useState)(false),
      open = _useState14[0],
      setOpen = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      isAlignRow = _useState15[0],
      setIsAlignRow = _useState15[1];

  var _useWindowDimensions = (0,useWindowDimensions/* default */.Z)(),
      width = _useWindowDimensions.width;

  var _useState16 = (0,react.useState)(false),
      drawerState = _useState16[0],
      setDrawerState = _useState16[1]; // sorting


  var _useState17 = (0,react.useState)(defaultSortValue),
      sorting = _useState17[0],
      setSorting = _useState17[1]; //selected States


  var _useState18 = (0,react.useState)({
    checkedLevels: router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.crl ? router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : (_router$query2$crl = _router$query2.crl) === null || _router$query2$crl === void 0 ? void 0 : _router$query2$crl.split(",") : [],
    checkedSpecializations: router !== null && router !== void 0 && (_router$query3 = router.query) !== null && _router$query3 !== void 0 && _router$query3.sp ? router === null || router === void 0 ? void 0 : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : (_router$query4$sp = _router$query4.sp) === null || _router$query4$sp === void 0 ? void 0 : _router$query4$sp.split(",") : [],
    checkedExam: router !== null && router !== void 0 && (_router$query5 = router.query) !== null && _router$query5 !== void 0 && _router$query5.ex ? router === null || router === void 0 ? void 0 : (_router$query6 = router.query) === null || _router$query6 === void 0 ? void 0 : (_router$query6$ex = _router$query6.ex) === null || _router$query6$ex === void 0 ? void 0 : _router$query6$ex.split(",") : []
  }),
      checkedState = _useState18[0],
      setCheckedState = _useState18[1]; // data prepare for checkboxes


  var checkboxDataForCourseLevel = levels && (levels === null || levels === void 0 ? void 0 : levels.length) > 0 ? levels === null || levels === void 0 ? void 0 : levels.map(function (item) {
    return {
      label: item === null || item === void 0 ? void 0 : item.levelName,
      value: item === null || item === void 0 ? void 0 : item.slug
    };
  }) : [];
  var checkboxDataSpecialization = specializations && (specializations === null || specializations === void 0 ? void 0 : specializations.length) > 0 ? specializations === null || specializations === void 0 ? void 0 : specializations.map(function (item) {
    return {
      label: item === null || item === void 0 ? void 0 : item.specializationName,
      value: item === null || item === void 0 ? void 0 : item.slug
    };
  }) : [];
  var checkboxDataForExam = exams && (exams === null || exams === void 0 ? void 0 : exams.length) > 0 ? exams === null || exams === void 0 ? void 0 : exams.map(function (item) {
    return {
      label: item === null || item === void 0 ? void 0 : item.examName,
      value: item === null || item === void 0 ? void 0 : item.slug
    };
  }) : []; // Filtering handlers
  // search levels

  var searchLevels = function searchLevels(value) {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setCheckedState(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        checkedLevels: value
      });
    });
    setPayload(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        crl: Array.from(new Set(value))
      });
    });
  }; // search specialization


  var searchSpecializations = function searchSpecializations(value) {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setCheckedState(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        checkedSpecializations: value
      });
    });
    setPayload(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        sp: Array.from(new Set(value))
      });
    });
  }; // search specialization


  var searchExams = function searchExams(value) {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setCheckedState(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        checkedExam: value
      });
    });
    setPayload(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        ex: Array.from(new Set(value))
      });
    });
  }; //Search by duration


  var searchByDuration = function searchByDuration(value) {
    setDurationIsChangable(false);
    setFeeIsChangable(false);
    var valueString = value === null || value === void 0 ? void 0 : value.map(function (item) {
      return item.toString();
    });
    setPayload(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        duration: valueString
      });
    });
  }; //Search by fees


  var searchByFees = function searchByFees(value) {
    setFeeIsChangable(false);
    setDurationIsChangable(false);
    var valueString = value === null || value === void 0 ? void 0 : value.map(function (item) {
      return item.toString();
    });
    setPayload(function (prevState) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prevState), {}, {
        tfees: valueString
      });
    });
  }; // Sorting handler


  var sortHandler = function sortHandler(item) {
    setFeeIsChangable(false);
    setDurationIsChangable(false);
    setSorting(item);

    var newPayload = uni_filtered_courses_objectSpread({}, payload);

    delete newPayload.sbp;
    delete newPayload.sbtfLH;
    delete newPayload.sbtfHL;
    delete newPayload.sbr;
    delete newPayload.sbp;
    newPayload[item.value] = 1;
    setPayload(newPayload);
  };

  var closeDrawer = function closeDrawer() {
    setDrawerState(false);
  };

  var openDrawer = function openDrawer() {
    setDrawerState(true);
  };

  var toggleDrawer = function toggleDrawer(newOpen) {
    return function () {
      setDrawerState(newOpen);
    };
  };

  var handleClick = function handleClick() {
    setOpen(!open);
  }; // reset handler


  var resetHandler = function resetHandler() {
    setFeeIsChangable(true);
    setDurationIsChangable(true);
    setPayload({
      page: 1,
      limit: 8
    });
    setSorting({
      value: "",
      label: "Default Sorting"
    });
    setCheckedState({
      checkedLevels: [],
      checkedSpecializations: [],
      checkedExam: []
    });
    setShowItem(8);
  }; // paginate handler


  var patinationHandler = function patinationHandler(event, page) {
    setFeeIsChangable(false);
    setDurationIsChangable(false);
    setPayload(function (prev) {
      return uni_filtered_courses_objectSpread(uni_filtered_courses_objectSpread({}, prev), {}, {
        page: page
      });
    });
  }; // data fetching


  (0,react.useEffect)(function () {
    var fetchCourses = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res, _res$data$levels, _res$data$exams, _res$data$specializat, _res$data$paginatedCo, _res$data$paginatedCo2, _res$data$courseDurat, _res$data$tuitionFee;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return api/* default.post */.Z.post("/public/university/all-courses/".concat(university_name), payload);

              case 4:
                res = _context.sent;

                if (res.data) {
                  setLevels((_res$data$levels = res.data.levels) !== null && _res$data$levels !== void 0 ? _res$data$levels : []);
                  setExams((_res$data$exams = res.data.exams) !== null && _res$data$exams !== void 0 ? _res$data$exams : []);
                  setSpecializations((_res$data$specializat = res.data.specializations) !== null && _res$data$specializat !== void 0 ? _res$data$specializat : []);

                  if (durationIsChangable) {
                    setCourseDuration((_res$data$courseDurat = res.data.courseDuration) !== null && _res$data$courseDurat !== void 0 ? _res$data$courseDurat : {});
                  }

                  if (feeIsChangable) {
                    setTutionFee((_res$data$tuitionFee = res.data.tuitionFee) !== null && _res$data$tuitionFee !== void 0 ? _res$data$tuitionFee : {});
                  }

                  setTotalCourses((_res$data$paginatedCo = res.data.paginatedCourse.courses) !== null && _res$data$paginatedCo !== void 0 ? _res$data$paginatedCo : []);
                  setPaginate((_res$data$paginatedCo2 = res.data.paginatedCourse) !== null && _res$data$paginatedCo2 !== void 0 ? _res$data$paginatedCo2 : {});
                }

                setLoading(false);
                router.push("/study/".concat(country_name, "/university/").concat(university_name, "/courses?").concat((0,utils/* objectToQueryString */.nZ)(payload, {
                  shallow: true
                })), undefined, {
                  shallow: true
                });
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setRespError(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchCourses() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchCourses();
  }, [payload]);

  var FilteredComponent = function FilteredComponent() {
    var _payload$duration, _payload$tfees;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) == 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (filtered_course_module_default()).filter_boxes_wrapper,
        children: [levels && (levels === null || levels === void 0 ? void 0 : levels.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filtered_course_module_default()).checkbox_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (filtered_course_module_default()).filter_title,
            children: "Course Level"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            data: checkboxDataForCourseLevel,
            onChange: searchLevels,
            selected: checkedState.checkedLevels,
            loading: loading,
            type: "normal"
          })]
        }), specializations && (specializations === null || specializations === void 0 ? void 0 : specializations.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filtered_course_module_default()).checkbox_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (filtered_course_module_default()).filter_title,
            children: "Specialization"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            onChange: searchSpecializations,
            data: checkboxDataSpecialization,
            selected: checkedState.checkedSpecializations,
            loading: loading,
            type: "normal"
          })]
        }), exams && (exams === null || exams === void 0 ? void 0 : exams.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filtered_course_module_default()).checkbox_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (filtered_course_module_default()).filter_title,
            children: "Eligibility Exam"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxCheckbox */.mf, {
            onChange: searchExams,
            data: checkboxDataForExam,
            selected: checkedState.checkedExam,
            loading: loading,
            type: "normal"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filtered_course_module_default()).filter_slider_wrapper,
          children: [(courseDuration === null || courseDuration === void 0 ? void 0 : courseDuration.maxDuration) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (filtered_course_module_default()).filter_title,
              children: "Course Duration"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxSlider */._k, {
              type: "normal",
              range: [parseInt(courseDuration.minDuration), parseInt(courseDuration.maxDuration)],
              value: payload !== null && payload !== void 0 && payload.duration && (payload === null || payload === void 0 ? void 0 : (_payload$duration = payload.duration) === null || _payload$duration === void 0 ? void 0 : _payload$duration.length) == 2 ? [parseInt(payload.duration[0]), parseInt(payload.duration[1])] : [parseInt(courseDuration.minDuration), parseInt(courseDuration.maxDuration)],
              onChange: searchByDuration,
              loading: loading,
              icon: "m",
              offset: "right"
            })]
          }), (tutionFee === null || tutionFee === void 0 ? void 0 : tutionFee.maxAmount) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (filtered_course_module_default()).filter_title,
              children: "Tution Fees(First Year)"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(advance/* FilterBoxSlider */._k, {
              type: "normal",
              range: [0, parseInt(tutionFee.maxAmount)],
              value: payload !== null && payload !== void 0 && payload.tfees && (payload === null || payload === void 0 ? void 0 : (_payload$tfees = payload.tfees) === null || _payload$tfees === void 0 ? void 0 : _payload$tfees.length) == 2 ? [parseInt(payload.tfees[0]), parseInt(payload.tfees[1])] : [0, parseInt(tutionFee.maxAmount)],
              onChange: searchByFees,
              loading: loading,
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiMoney */.iFN, {}),
              offset: "left"
            })]
          })]
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (filtered_course_module_default()).course_component_container,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heading, {
        universityProfileData: universityProfileData,
        courseOverviewText: courseOverviewText
      }), width > 992 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(breadcrumb, {
          universityProfileData: universityProfileData
        }), totalCourses && (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(show_paginate_text/* default */.Z, {
          paginate: paginate
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((filtered_course_module_default()).filtered_wrapper, " course_filtered_wrapper"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (filtered_course_module_default()).filtered_heading,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (filtered_course_module_default()).fi_heading_wrapper,
            children: [width > 992 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (filtered_course_module_default()).btn_container,
                children: [(totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  role: "button",
                  className: "".concat((filtered_course_module_default()).collapse_btn, " ").concat((filtered_course_module_default()).btn_toggle),
                  onClick: handleClick,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSliders */.NNy, {
                    className: (filtered_course_module_default()).collapse_icon
                  }), !open ? "Show" : "Hide", " filter"]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  role: "button",
                  onClick: resetHandler,
                  className: (filtered_course_module_default()).collapse_btn,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tb_index_esm/* TbRefresh */.T8D, {
                    className: (filtered_course_module_default()).collapse_icon
                  }), "Reset"]
                })]
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (filtered_course_module_default()).mobile_btn,
                children: [totalCourses && (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: width < 660 && /*#__PURE__*/(0,jsx_runtime.jsx)(show_paginate_text/* default */.Z, {
                    paginate: paginate
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (filtered_course_module_default()).collapse_btn,
                  onClick: openDrawer,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSliders */.NNy, {
                    className: (filtered_course_module_default()).collapse_icon
                  }), "Show filter"]
                })]
              })
            }), (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: width > 660 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (filtered_course_module_default()).right_wrapper,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (filtered_course_module_default()).show_item_wrapper,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (filtered_course_module_default()).show,
                    children: "Show : "
                  }), showItemsData.map(function (item, i) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        onClick: function onClick() {
                          setShowItem(item.number);
                          handlerShowItem(item.number);
                        },
                        className: "".concat((filtered_course_module_default()).number, " ").concat(item.number == showItem ? (filtered_course_module_default()).active : ""),
                        children: item === null || item === void 0 ? void 0 : item.number
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (filtered_course_module_default()).line,
                        children: "/"
                      })]
                    }, i);
                  })]
                }), width > 992 ? /*#__PURE__*/(0,jsx_runtime.jsx)(card_layout_controller, {
                  isAlignRow: isAlignRow,
                  setIsAlignRow: setIsAlignRow
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (filtered_course_module_default()).shorting_filter,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                    id: "selectID",
                    instanceId: "testid",
                    styles: customStyles,
                    placeholder: "Default sorting",
                    onChange: sortHandler,
                    options: sortingOptions,
                    defaultValue: sorting,
                    value: sortingOptions.filter(function (item) {
                      return item.value == sorting.value;
                    })
                  })
                })]
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })]
          })
        }), width > 992 && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
            "in": open,
            timeout: "auto",
            unmountOnExit: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FilteredComponent, {})
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          marginTop: "20px"
        },
        children: (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) == 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (filtered_course_module_default()).no_course_found,
          children: "No Course Found"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          container: true,
          spacing: {
            xs: 2,
            sm: 1
          },
          children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: new Array(8).fill(1).map(function (_, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: isAlignRow ? 12 : 6,
                md: isAlignRow ? 12 : 4,
                lg: isAlignRow ? 12 : 3,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                  animation: "wave",
                  variant: "rectangular",
                  width: "100%",
                  height: isAlignRow ? 80 : 275,
                  style: {
                    borderRadius: 8
                  }
                })
              }, i);
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: totalCourses.map(function (course, i) {
              var _course$level, _course$tuition, _course$tuition2;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: isAlignRow ? 12 : 6,
                md: isAlignRow ? 12 : 4,
                lg: isAlignRow ? 12 : 3,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(course_card/* default */.Z, {
                  isAlignRow: isAlignRow,
                  link: "/study/".concat(country_name, "/university/").concat(university_name, "/").concat(course === null || course === void 0 ? void 0 : course.slug),
                  name: course === null || course === void 0 ? void 0 : course.courseName,
                  level: course === null || course === void 0 ? void 0 : (_course$level = course.level) === null || _course$level === void 0 ? void 0 : _course$level.levelName,
                  exams: course === null || course === void 0 ? void 0 : course.courseExam,
                  session: course === null || course === void 0 ? void 0 : course.sessionName,
                  duration: course === null || course === void 0 ? void 0 : course.courseDuration,
                  intakes: course === null || course === void 0 ? void 0 : course.intake,
                  amountFrom: course === null || course === void 0 ? void 0 : (_course$tuition = course.tuition) === null || _course$tuition === void 0 ? void 0 : _course$tuition.amountFrom,
                  amountTo: course === null || course === void 0 ? void 0 : (_course$tuition2 = course.tuition) === null || _course$tuition2 === void 0 ? void 0 : _course$tuition2.amountTo,
                  countryCurrency: universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countryCurrency
                }, i)
              }, i);
            })
          })
        })
      }), totalCourses && (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(pagination/* default */.Z, {
        paginate: paginate,
        paginationHandler: patinationHandler
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SwipeableDrawer/* default */.Z, {
        anchor: "left",
        classes: {
          paper: (filtered_course_module_default()).person_list_drawer
        },
        open: drawerState,
        onClose: toggleDrawer(false),
        onOpen: toggleDrawer(true),
        disableSwipeToOpen: false,
        ModalProps: {
          keepMounted: true
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (filtered_course_module_default()).filter_drawer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (filtered_course_module_default()).filter_drawer_head,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (filtered_course_module_default()).filter_title,
              children: "Filter Your Result"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiX */.q5L, {
              onClick: closeDrawer,
              className: (filtered_course_module_default()).close_icon
            })]
          }), (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [width < 660 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (filtered_course_module_default()).mobile_sorting_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (filtered_course_module_default()).show_item_wrapper,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (filtered_course_module_default()).show,
                  children: "Show : "
                }), showItemsData.map(function (item, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      onClick: function onClick() {
                        setShowItem(item.number);
                        handlerShowItem(item.number);
                      },
                      className: "".concat((filtered_course_module_default()).number, " ").concat(item.number == showItem ? (filtered_course_module_default()).active : ""),
                      children: item === null || item === void 0 ? void 0 : item.number
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: (filtered_course_module_default()).line,
                      children: "/"
                    })]
                  }, i);
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (filtered_course_module_default()).shorting_filter,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                  id: "selectID",
                  instanceId: "testid",
                  styles: customStyles,
                  placeholder: "Default sorting",
                  onChange: sortHandler,
                  options: sortingOptions,
                  defaultValue: sorting,
                  value: sortingOptions.filter(function (item) {
                    return item.value == sorting.value;
                  })
                })
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FilteredComponent, {})]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: "No course Found"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (filtered_course_module_default()).filter_all_btn_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              onClick: resetHandler,
              className: "btn btn-outline btn-sm",
              children: "Reset All"
            }), (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              className: "btn btn-primary btn-sm",
              onClick: closeDrawer,
              children: "Apply All Filters"
            })]
          })]
        })
      })]
    })
  });
};
/* harmony default export */ var uni_filtered_courses = (UniFilteredCourses);
// EXTERNAL MODULE: ./_unisearch/theme/layout/index.js + 17 modules
var layout = __webpack_require__(81496);
;// CONCATENATED MODULE: ./pages/study/[country_name]/university/[university_name]/courses/index.jsx







var Courses = function Courses(_ref) {
  var universityProfileData = _ref.universityProfileData,
      courseOverviewText = _ref.courseOverviewText,
      country_name = _ref.country_name,
      university_name = _ref.university_name,
      coursesData = _ref.coursesData,
      courseDuration = _ref.courseDuration,
      exams = _ref.exams,
      levels = _ref.levels,
      specializations = _ref.specializations,
      totalCourseCount = _ref.totalCourseCount,
      tutionFee = _ref.tutionFee,
      totalCourses = _ref.totalCourses,
      paginate = _ref.paginate;
  var listCourseLd = totalCourses && (totalCourses === null || totalCourses === void 0 ? void 0 : totalCourses.length) > 0 && totalCourses.map(function (item, i) {
    var _item$specialization;

    var courseLd = "\n      {\n        \"@type\": \"ListItem\",\n        \"position\": ".concat(i + 1, ",\n        \"item\": {\n          \"@type\": \"Course\",\n          \"url\":\"").concat("https://myunisearch.com", "/study/").concat(country_name, "/university/").concat(university_name, "/").concat(item === null || item === void 0 ? void 0 : item.slug, "\",\n          \"name\": \"").concat(item === null || item === void 0 ? void 0 : item.courseName, "\",\n          \"description\": \"").concat(item === null || item === void 0 ? void 0 : item.courseName, " | ").concat(item === null || item === void 0 ? void 0 : (_item$specialization = item.specialization) === null || _item$specialization === void 0 ? void 0 : _item$specialization.specializationName, " | UniSearch\",\n          \"provider\": {\n            \"@type\": \"Organization\",\n            \"name\": \"").concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, "\",\n            \"sameAs\": \"").concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.website, "\"\n          }\n        }\n      }\n      ");
    return courseLd;
  });

  var JsonLd = function JsonLd() {
    {
      return {
        __html: "\n        [\n          {\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"Organization\",\n            \"name\": \"UniSearch\",\n            \"alternateName\": \"UniSearch\",\n            \"url\": \"https://myunisearch.com/\",\n            \"logo\": \"".concat("https://myunisearch.com", "/assets/logo_dark.png\",\n            \"sameAs\": [\n              \"https://www.facebook.com/UniSearchIndia\",\n              \"https://twitter.com/myunisearch\",\n              \"https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw\",\n              \"https://myunisearch.com/\"\n            ]\n          },\n          {\n          \"@context\": \"https://schema.org\",\n          \"@type\": \"ItemList\",\n          \"itemListElement\": [").concat(listCourseLd, "]\n        }\n      ]\n    ")
      };
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* LayoutMain */.Ku, {
    footer_with_evaluation: true,
    title: universityProfileData ? "".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " - Courses") : "",
    metaTitle: universityProfileData ? "".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " - Courses") : "",
    metaDescription: courseOverviewText ? (0,helpers/* excerpt */.X1)(courseOverviewText, 300) : "Explore the courses ".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " has to offer to find the right program for you!"),
    metaUrl: "".concat("https://myunisearch.com", "/study/").concat(country_name, "/university/").concat(university_name, "/courses"),
    JsonLd: JsonLd,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(university/* UniProfileWrapper */.au, {
        isBanner: false,
        uniProfileData: universityProfileData || {},
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(uni_filtered_courses, {
          courseOverviewText: courseOverviewText,
          country_name: country_name,
          university_name: university_name,
          coursesData: coursesData,
          universityProfileData: universityProfileData,
          courseDurationData: courseDuration,
          examsData: exams,
          levelsData: levels,
          specializationsData: specializations,
          totalCourseCountData: totalCourseCount,
          tutionFeeData: tutionFee,
          totalCoursesData: totalCourses,
          paginateData: paginate
        })
      })
    })
  });
};

var __N_SSP = true;
/* harmony default export */ var courses = (Courses);

/***/ }),

/***/ 42237:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study/[country_name]/university/[university_name]/courses",
      function () {
        return __webpack_require__(81032);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54650:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter_option":"filter_box_checkbox_filter_option__NcRea","searach_wrapper":"filter_box_checkbox_searach_wrapper__m5aK4","searach_icon":"filter_box_checkbox_searach_icon__AVuNj","option_title_wrapper":"filter_box_checkbox_option_title_wrapper__VnZ2J","icon":"filter_box_checkbox_icon__VkJWc","filter_checkbox_wrapper":"filter_box_checkbox_filter_checkbox_wrapper__cwMFi"};

/***/ }),

/***/ 4644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter_option":"filter_box_slider_filter_option__4nveH","option_title_wrapper":"filter_box_slider_option_title_wrapper__1t7go","currncy":"filter_box_slider_currncy__0CpNb","filter_slider_wrapper":"filter_box_slider_filter_slider_wrapper__iODVe","slider_range_text":"filter_box_slider_slider_range_text__RfE4d","slideContainer":"filter_box_slider_slideContainer__82VJv"};

/***/ }),

/***/ 81648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"course_card":"course_card_course_card__AxRrI","course_card_title":"course_card_course_card_title__vg3Cj","course_card_info_lists":"course_card_course_card_info_lists__adoRI","course_card_icon":"course_card_course_card_icon__Q_A3H","course_card_text":"course_card_course_card_text__BKIGI","card_text_last":"course_card_card_text_last__Z9Fbt","course_card_link":"course_card_course_card_link__Wnw7V","more_intake_wrapper":"course_card_more_intake_wrapper__0gOlg","more_intake":"course_card_more_intake__yi0Bc","more_intake_num":"course_card_more_intake_num__pVWwv","align_row":"course_card_align_row__5bU4S"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ }),

/***/ 47022:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_uni_brief":"uni_brief_section_uni_brief__HDqFd","brief_wrapper":"uni_brief_brief_wrapper__L8JIS","brief_left_wrapper":"uni_brief_brief_left_wrapper__LVU6c","uni_logo_wrapper":"uni_brief_uni_logo_wrapper__GRSAp","uni_brief_info":"uni_brief_uni_brief_info__K7_DQ","brief_right_wrapper":"uni_brief_brief_right_wrapper__SV0_H","info_rating_stars":"uni_brief_info_rating_stars__kasMS","info_rating_number":"uni_brief_info_rating_number__QLgq6","uni_web_link":"uni_brief_uni_web_link__KgEaj","compare_wrapper":"uni_brief_compare_wrapper__qDVt3","icon_heart":"uni_brief_icon_heart__kAVta","icon_swap":"uni_brief_icon_swap__MeiHF","rating_wrapper":"uni_brief_rating_wrapper__xFFKY","modal_header":"uni_brief_modal_header__NDrGT","modal_body":"uni_brief_modal_body__lfBwt","modal_title":"uni_brief_modal_title__E8rR7","modal_description":"uni_brief_modal_description__yvCMC","action_btn":"uni_brief_action_btn__yH_0f","active_btn":"uni_brief_active_btn__VgSdv"};

/***/ }),

/***/ 92223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__TfvaH","link_area":"breadcrumb_link_area__cw1fX","link":"breadcrumb_link__9kSTZ"};

/***/ }),

/***/ 66603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid_wrapper":"card_layout_grid_wrapper__ATmBj","active":"card_layout_active__NLZ8U","inActive":"card_layout_inActive__1cVS8"};

/***/ }),

/***/ 71875:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"heading_heading_wrapper__De3HD","heading":"heading_heading__7RJoj","short_description":"heading_short_description__rdH6O"};

/***/ }),

/***/ 43375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"course_component_container":"filtered_course_course_component_container__hG4XQ","filtered_wrapper":"filtered_course_filtered_wrapper__dJGv6","active":"filtered_course_active__Vk9CB","inActive":"filtered_course_inActive__okPEz","filtered_heading":"filtered_course_filtered_heading__yDyme","fi_heading_wrapper":"filtered_course_fi_heading_wrapper___NNoc","btn_container":"filtered_course_btn_container__tS90a","mobile_btn":"filtered_course_mobile_btn__vdxOl","showing":"filtered_course_showing__1EoF8","right_wrapper":"filtered_course_right_wrapper__GZxuf","shorting_filter":"filtered_course_shorting_filter__izp8U","collapse_btn":"filtered_course_collapse_btn__3lZ7t","btn_toggle":"filtered_course_btn_toggle__E0kq0","collapse_icon":"filtered_course_collapse_icon__7yswr","show_item_wrapper":"filtered_course_show_item_wrapper__inNLS","number":"filtered_course_number__SmoL4","line":"filtered_course_line__xeyGB","no_course_found":"filtered_course_no_course_found__01IrZ","filter_boxes_wrapper":"filtered_course_filter_boxes_wrapper__shzA9","filter_title":"filtered_course_filter_title__DgOzu","filter_slider_wrapper":"filtered_course_filter_slider_wrapper__c27cf","filter_drawer":"filtered_course_filter_drawer__58Ivc","filter_all_btn_wrapper":"filtered_course_filter_all_btn_wrapper__z4pPM","mobile_sorting_wrapper":"filtered_course_mobile_sorting_wrapper__KJPz7","filter_drawer_head":"filtered_course_filter_drawer_head__4lftT","close_icon":"filtered_course_close_icon__qxiHH"};

/***/ }),

/***/ 47656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uni_hero":"uni_hero_with_video_uni_hero__EYNPe","video_wrapper":"uni_hero_with_video_video_wrapper__zyLOm","overlay":"uni_hero_with_video_overlay__H6twK"};

/***/ }),

/***/ 13777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_links___next__muTBt","section_links":"uni_links_section_links__xN6Wg","links_wrapper":"uni_links_links_wrapper__VqfJE","links_container":"uni_links_links_container__y3gQ7","link_lists":"uni_links_link_lists__aXFrS","link_list_item":"uni_links_link_list_item__1VTz2","active":"uni_links_active__w_Jji","currencyChanger":"uni_links_currencyChanger__AAlM8"};

/***/ }),

/***/ 98576:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_profile_banner___next__ExBkw","section_banner":"uni_profile_banner_section_banner__7vgrZ","banner_wrapper":"uni_profile_banner_banner_wrapper__widLd","banner_image":"uni_profile_banner_banner_image__R_T_c"};

/***/ }),

/***/ 98281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"uni_profile_wrapper_root__IDxrR","uni_breacrumbs":"uni_profile_wrapper_uni_breacrumbs__jGbp2"};

/***/ }),

/***/ 88740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guest_form_review_wrapper__u7nu7","rating_wrapper":"guest_form_review_rating_wrapper__I5gca","input_wrapper":"guest_form_review_input_wrapper__Y_rPr","text_input_wrapper":"guest_form_review_text_input_wrapper__3sak2","action_btn":"guest_form_review_action_btn__C_nI2","phoneInput":"guest_form_review_phoneInput__ui0mH"};

/***/ }),

/***/ 42891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message_component_wrapper":"message_message_component_wrapper__1ieyP","buddy_msg_wrapper":"message_buddy_msg_wrapper__DK00E","msg_time":"message_msg_time__pkHde","msg_wrapper":"message_msg_wrapper__bcN0z","image_wrapper":"message_image_wrapper__75POr","replymsg":"message_replymsg__Q1uk8","my_msg_time":"message_my_msg_time__RxJqO","my_msg":"message_my_msg__0MTvI","mark":"message_mark__3uB3z","heading":"message_heading__nN8Pc","details_wrapper":"message_details_wrapper__KVYfo","msg_footer_wrapper":"message_msg_footer_wrapper__S9kxU","action":"message_action__0Olen","left":"message_left__1Zl0o","action_btn":"message_action_btn__l9bDv","conversation_wrapper":"message_conversation_wrapper__YdB1H","conversation_wrapper_child":"message_conversation_wrapper_child__50fY7","details_wrapper2":"message_details_wrapper2__mMBhj","empty_detail_wrapper":"message_empty_detail_wrapper__SuI8J","my_msg_wrapper":"message_my_msg_wrapper__PTorz","heading_menu":"message_heading_menu__Kqe7o"};

/***/ }),

/***/ 6867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"active_chatt_box":"list_active_chatt_box__MbZyB","chatt":"list_chatt__Y9S5q","time":"list_time__brnw_","image_wrapper":"list_image_wrapper__waMIN","active_chatt_box_modal":"list_active_chatt_box_modal___BrsY","chatt_box":"list_chatt_box__GiEyE","chatt_msg":"list_chatt_msg__KF_sP","chatt_box_wrapper":"list_chatt_box_wrapper__4qk6k","list_wrapper":"list_list_wrapper__DX7IH","search_input":"list_search_input__2YMvn","search_icon":"list_search_icon__3ZZ8U","header_wrapper":"list_header_wrapper__elCsP","btn_group":"list_btn_group__POPeU","search_input_modal":"list_search_input_modal___ZcDT","modal_body":"list_modal_body__nHnG8","no_found":"list_no_found__wMd8W","btn_close":"list_btn_close__2T9Vb","btn_add_user":"list_btn_add_user__9cjH4","btn_plus":"list_btn_plus__B7L_4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,260,1086,8907,2884,8719,8322,5824,3480,5551,5260,926,3063,6665,3023,5996,1010,1496,5603,9774,2888,179], function() { return __webpack_exec__(42237); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);